webpackJsonp([1],{

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return USER_UPDATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_idb__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions_api__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_protocol__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);






var _newProtocol$saveProt;






var AUTH_REQUEST = 'AUTH_REQUEST';
var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = 'AUTH_ERROR';
var AUTH_LOGOUT = 'AUTH_LOGOUT';
var USER_REQUEST = 'USER_REQUEST';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_ERROR = 'USER_ERROR';
var USER_UPDATE = 'USER_UPDATE';

/* harmony default export */ __webpack_exports__["i"] = (_newProtocol$saveProt = {
  newProtocol: function newProtocol(context) {
    return new __WEBPACK_IMPORTED_MODULE_7__classes_protocol__["a" /* default */]();
  },
  saveProtocol: function saveProtocol(context, _ref) {
    var _this = this;

    var protocol = _ref.protocol,
        local = _ref.local,
        _ref$sendMails = _ref.sendMails,
        sendMails = _ref$sendMails === undefined ? false : _ref$sendMails;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              protocol.draft = local;

              if (!(!local && navigator.onLine)) {
                _context.next = 17;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_6__functions_api__["a" /* default */].updateProtocol(protocol, sendMails);

            case 5:
              response = _context.sent;
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_5__functions_idb__["a" /* default */].deleteProtocol(protocol);

            case 8:
              return _context.abrupt('return', response);

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](2);

              console.log(_context.t0);
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__functions_idb__["a" /* default */].updateProtocol(protocol));

            case 15:
              _context.next = 18;
              break;

            case 17:
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__functions_idb__["a" /* default */].updateProtocol(protocol));

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 11]]);
    }))();
  },
  getProtocols: function getProtocols(context, _ref2) {
    var _this2 = this;

    var local = _ref2.local,
        page = _ref2.page,
        filters = _ref2.filters;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__functions_idb__["a" /* default */].getProtocols());

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getProtocol: function getProtocol(context, _ref3) {
    var _this3 = this;

    var id = _ref3.id,
        local = _ref3.local;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', local ? __WEBPACK_IMPORTED_MODULE_5__functions_idb__["a" /* default */].getProtocol(id) : __WEBPACK_IMPORTED_MODULE_6__functions_api__["a" /* default */].getProtocol(id));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getProtocolWhereApiID: function getProtocolWhereApiID(context, _ref4) {
    var _this4 = this;

    var id = _ref4.id;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__functions_idb__["a" /* default */].getProtocolWhereApiID(id));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  deleteProtocolFromIdb: function deleteProtocolFromIdb(context, _ref5) {
    var protocol = _ref5.protocol;

    return __WEBPACK_IMPORTED_MODULE_5__functions_idb__["a" /* default */].deleteProtocol(protocol);
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newProtocol$saveProt, USER_REQUEST, function (_ref6) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;

  commit(USER_REQUEST);
  __WEBPACK_IMPORTED_MODULE_8_axios___default()({ url: 'auth/user', method: 'GET' }).then(function (resp) {
    localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(resp.data));
    commit(USER_SUCCESS, resp.data);
  }).catch(function () {
    commit(USER_ERROR);
    // if resp is unauthorized, logout, to
    dispatch(AUTH_LOGOUT);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newProtocol$saveProt, AUTH_REQUEST, function (_ref7, user) {
  var commit = _ref7.commit,
      dispatch = _ref7.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    commit(AUTH_REQUEST);
    __WEBPACK_IMPORTED_MODULE_8_axios___default()({ url: 'auth/login', data: user, method: 'POST' }).then(function (resp) {
      var token = resp.data.token.token;
      var tokenType = resp.data.token.token_type;
      localStorage.setItem('user-token', tokenType + ' ' + token);
      localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(resp.data.user));
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.defaults.headers.common['Authorization'] = tokenType + ' ' + token;
      commit(AUTH_SUCCESS, token);
      commit(USER_SUCCESS, resp.data.user);
      commit('modalAuthError', false);
      resolve(resp);
    }).catch(function (error) {
      commit(AUTH_ERROR, error.response.data.message);
      localStorage.removeItem('user-token');
      reject(error.response.data.message);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newProtocol$saveProt, AUTH_LOGOUT, function (_ref8) {
  var commit = _ref8.commit,
      dispatch = _ref8.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_8_axios___default()({ url: 'auth/logout', method: 'POST' }).then(function (resp) {
      commit(AUTH_LOGOUT);
      localStorage.removeItem('user-token');
      localStorage.removeItem('user');
      // remove the axios default header
      delete __WEBPACK_IMPORTED_MODULE_8_axios___default.a.defaults.headers.common['Authorization'];
      resolve();
    }).catch(function (error) {
      commit(AUTH_LOGOUT);
      localStorage.removeItem('user-token');
      localStorage.removeItem('user');
      delete __WEBPACK_IMPORTED_MODULE_8_axios___default.a.defaults.headers.common['Authorization'];
      console.log(error);
      reject(error);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newProtocol$saveProt, AUTH_ERROR, function (_ref9) {
  var commit = _ref9.commit,
      dispatch = _ref9.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    commit(AUTH_LOGOUT);
    localStorage.removeItem('user-token');
    localStorage.removeItem('user');
    delete __WEBPACK_IMPORTED_MODULE_8_axios___default.a.defaults.headers.common['Authorization'];
    resolve();
  });
}), _newProtocol$saveProt);

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



var DB_NAME = 'protocol';
var STORAGE_NAME = 'protocols';
var DB_VERSION = 3;
var DB = void 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  getDb: function getDb() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (DB) {
                  return resolve(DB);
                }
                var request = window.indexedDB.open(DB_NAME, DB_VERSION);
                request.onerror = function (e) {
                  console.log('Error opening db', e);
                  // eslint-disable-next-line prefer-promise-reject-errors
                  reject('Error');
                };
                request.onsuccess = function (e) {
                  DB = e.target.result;
                  resolve(DB);
                };
                request.onupgradeneeded = function (e) {
                  console.log(e);
                  console.log(e.oldVersion);
                  var db = e.target.result;
                  if (e.oldVersion < 1) {
                    db.createObjectStore(STORAGE_NAME, { autoIncrement: true, keyPath: 'id' });
                    request.transaction.objectStore(STORAGE_NAME).createIndex('api_id_idx', 'api_id', { unique: false });
                  } else {
                    request.transaction.objectStore(STORAGE_NAME).createIndex('api_id_idx', 'api_id', { unique: false });
                  }
                };
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  deleteProtocol: function deleteProtocol(protocol) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var db;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getDb();

            case 2:
              db = _context2.sent;
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                var trans = db.transaction([STORAGE_NAME], 'readwrite');
                trans.oncomplete = function () {
                  resolve();
                };
                var store = trans.objectStore(STORAGE_NAME);
                store.delete(protocol.id);
              }));

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getProtocolWhereApiID: function getProtocolWhereApiID(apiId) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var db, trans, store, apiIdIndex, request;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getDb();

            case 2:
              db = _context3.sent;
              trans = db.transaction([STORAGE_NAME], 'readonly');
              store = trans.objectStore(STORAGE_NAME);
              apiIdIndex = store.index('api_id_idx');
              request = apiIdIndex.getAll(apiId);
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                request.onsuccess = function () {
                  if (request.result !== undefined) {
                    resolve(request.result);
                  } else {
                    resolve([]);
                  }
                };
              }));

            case 8:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getProtocols: function getProtocols() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var db;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.getDb();

            case 2:
              db = _context4.sent;
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                var trans = db.transaction([STORAGE_NAME], 'readonly');
                trans.oncomplete = function () {
                  resolve(protocols);
                };
                var store = trans.objectStore(STORAGE_NAME);
                var protocols = [];
                store.openCursor().onsuccess = function (e) {
                  var cursor = e.target.result;
                  if (cursor) {
                    protocols.push(cursor.value);
                    cursor.continue();
                  }
                };
              }));

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getProtocol: function getProtocol(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var db, trans, store, objectStoreRequest;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.getDb();

            case 2:
              db = _context5.sent;
              trans = db.transaction([STORAGE_NAME], 'readonly');
              store = trans.objectStore(STORAGE_NAME);
              _context5.next = 7;
              return store.get(+id);

            case 7:
              objectStoreRequest = _context5.sent;
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                trans.oncomplete = function () {
                  var protocol = objectStoreRequest.result;
                  resolve(protocol);
                };
              }));

            case 9:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  updateProtocol: function updateProtocol(protocol) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var db;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this6.getDb();

            case 2:
              db = _context6.sent;
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                var trans = db.transaction([STORAGE_NAME], 'readwrite');
                trans.oncomplete = function () {
                  var resp = objectStoreRequest.result;
                  resolve(resp);
                };
                var store = trans.objectStore(STORAGE_NAME);
                var objectStoreRequest = store.put(protocol);
              }));

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  main: {
    currency: 'EUR.',
    button_success: 'Ок',
    button_apply: 'OK',
    button_save: 'Speichern',
    button_save_and_send_mails: 'Email versenden',
    button_copy: 'Duplizieren',
    warning_copy: 'Wollen Sie dieses Protokoll duplizieren? Dabei werden alle Daten außer Unterschriften und Email-Adressen übernommen.',
    button_delete: 'Löschen',
    delete_warning: 'Möchten Sie dieses Protokoll wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    button_delete_room: 'Raum löschen',
    delete_room_warning: 'Möchten Sie diesen Raum wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    button_cancel: 'Abbrechen',
    button_clear: 'Clear',
    button_add: 'Neus Protokoll+',
    button_add_user: 'Benutzer hinzufügen',
    button_add_image: 'Bild hinzufügen +',
    button_get_pdf: 'PDF generieren',
    button_synchronize: 'Synchronisieren',
    button_logout: 'Abmelden',
    images: 'images',
    image: 'image',
    out_of_sync: 'Nicht synchronisiert',
    protocols: 'Protokolle',
    boolean: {
      true: 'Ja',
      false: 'Nein'
    },
    login: 'Name',
    button_login: 'Anmelden',
    auth_header: 'Anmeldung',
    password: 'Passwort',
    isset_protocol_local_version: 'Wichtig! Für dieses Protokoll existiert bereits eine lokale nicht sinchronisierte Version.',
    open_local_version: 'Lokale version öffnen',
    delete_local_version: 'Lokale Version löschen'
  },
  users: 'Benutzer',
  user: {
    name: 'Name',
    password: 'password',
    login: 'Benutzername',
    is_admin: 'Administrator'
  },
  protocol: {
    status: 'Status',
    draft: 'Entwurf',
    not_synchronized: 'Nicht synchronisiert',
    date: 'Datum',
    email_tenant: 'Email Nachmieter',
    email_old_tenant: 'Email Vormieter',
    email_owner: 'Email Eigentümer',
    email_inspector: 'Email Zeuge',
    header: 'AK Immobilienverwaltung GmbH',
    button_save: 'Speichern',
    button_save_and_close: 'Speichern & schließen',
    cause: {
      preliminary: 'Vorabnahme-',
      final: 'Endabnahme-',
      state: 'Zustands-',
      transmission: 'Übergabeprotokoll'
    },
    floor: 'Etage',
    location: {
      left: 'links',
      right: 'rechts',
      middle: 'mitte',
      behind: 'hinten',
      hallway: 'vorn',
      vhs: 'VHS',
      hhs: 'HHS'
    },
    structure_header: 'Die Wohnung besteht aus:',
    structure: {
      room: 'Zimmer',
      bathroom: 'Bad/Dusche mit WC alt/neu',
      restroom: 'WC innen/außen',
      kitchen: 'Küche/Kochnische',
      hallway: 'Diele/Flur',
      balcony: 'Balkon(e)/Wintergarten',
      terrace: 'Terrasse',
      pantry: 'Speisekammer',
      basement: 'Abstellraum',
      basement_number: 'Kellerraum Nr.',
      attic: 'Dachbodenanteil Nr.',
      garden: 'Gartenanteil'
    },
    furniture_header: 'Ausstattung:',
    furniture: {
      heating: {
        district: 'Fernheizung',
        gas: 'Gasetagenheizung',
        central: 'Öl/Gaszentralheizung',
        other: 'Sonstiges'
      },
      tv: {
        antenna: 'Gemeinschaftsantenne',
        cable: 'Kabelanschluß V/M',
        satellite: 'Sat-Anlage V/M '
      },
      other: {
        bicycle_storage: 'Fahrradkeller',
        lift: 'Fahrstuhl',
        intercom: 'Gegensprechanlage',
        shared_washing_machine: 'Gemeinschafts-Waschmaschine',
        floor: 'Trockenkeller/-boden'
      }
    },
    meters_data_header: 'Zählerstände:',
    meters_data: {
      electricity_1: 'Strom 1:',
      electricity_1_data: 'Zählernummer:',
      electricity_2: 'Strom 2:',
      electricity_2_data: 'Zählernummer:',
      gas: 'Gas:',
      gas_data: 'Zählernummer:',
      hot_water_1: 'Warmwasser Bad:',
      cold_water_1: 'Kaltwasser Bad: ',
      hot_water_2: 'Warmwasser Kü.:',
      cold_water_2: 'Kaltwasser Kü.: ',
      heat: 'Wärmemenge:',
      intermediate_counter: 'Zwischenzähler:'
    },
    rooms: {
      button_add: 'Raum hinzufügen',
      kitchen: 'Küche',
      room: 'Raum',
      bathroom: 'Bad',
      guest_bathroom: 'Gäste-WC, 2. Bad',
      access: 'Schlüssel vorhanden',
      hall: 'Flur',
      ceiling: 'Decke',
      walls: 'Wände',
      window: 'Fenster',
      doors: 'Türen',
      radiator: 'Heizkörper',
      radiator_value: 'Stand (kommagetrennt) ',
      plinth: 'Fußleisten',
      floor: 'Fußboden',
      flooring: 'Fußbodenbelag',
      tenants_property: 'Mietereigentum (nicht mitvermietet)',
      notes: 'Notiz',
      boiler_gas: 'Warmwassergastherme',
      boiler_flowing: 'Elt-Durchlauferhitzer',
      boiler_electric: 'Elt-Boiler',
      exist_boiler_other: 'Sonstiges',
      equipment: 'Einbauküche',
      material: 'Holz-/Kunststoff-/Metall-/Doppelfenster/einfach-/iso-verglast',
      tile: 'Terrazzo/Fliesen/PVC-Fußboden',
      other: 'Sonstiges:',
      bathroom_set: 'Badgarnitur',
      bath: 'freistehende/Einbau-Wanne/Duschwanne, WC, Bidet, Spiegel',
      bath_structure: {
        freistehende: 'Freistehende Wanne',
        einbau: 'EinbauWanne',
        dusch: 'Duschwanne',
        wc: 'WC',
        bidet: 'Bidet',
        spiegel: 'Spiegel'
      },
      washbasin: 'Waschbecken, Ablage, Handtuchhalter, Papierhalter, Duschkabine, Wannenaufsatz',
      washbasin_structure: {
        waschbecken: 'Waschbecken',
        ablage: 'Ablage',
        handtuchhalter: 'Handtuchhalter',
        papierhalter: 'Papierhalter',
        duschkabine: 'Duschkabine',
        wannenaufsatz: 'Wannenaufsatz'
      },
      wall_tile: 'Wandfliesen raumhoch, türhoch , -niedriger | Farbe',
      wall_tile_structure: {
        wandfliesen: 'Wandfliesen',
        raumhoch: 'raumhoch',
        halbhoch: 'halbhoch',
        turhoch: 'türhoch | Farbe'
      }
    },
    object: 'Objekt',
    tenant: 'Mieter',
    street: 'Straße',
    signature_owner: 'Eigentümer',
    signature_old_tenant: 'Vormieter',
    signature_inspector: 'Zeuge',
    signature_tenant: 'Nachmieter',
    basement_description: 'Keller',
    balcony_description: 'Balkon',
    remarks: 'Bemerkungen',
    state_header: 'Das Protokoll soll Aufschluss über das Mindestmaß der durchzuführenden Arbeiten und den Zustand ' + 'der Wohnung geben. Hinzu kommen die Arbeiten, welche 1. zum Zeitpunkt der Besichtigung nicht sichtbar, ' + '2. offensichtlich übersehen, 3. verdeckt oder verschwiegen wurden.',
    maintenance_boiler_header: 'Die Thermen-/Heizkesselwartung',
    maintenance_boiler_done: 'wurde am ',
    maintenance_boiler_not_done: 'muss belegt werden',
    maintenance_boiler_executor_owner: 'durch Vermieter',
    warmly_pays: 'Heizkostenverteiler sollen abgelesen werden',
    warmly_pays_tenant: 'ja (Die Kosten der Zwischenablesung trägt/tragen der/die Mieter)',
    warmly_pays_owner: 'nein',
    tenant_eliminate_defects: 'Der Mieter verpflichtet sich, die Mängel vollständig und fachgerecht zu beseitigen bis zum',
    tenant_warned_of_deadline: 'Der/die Mieter wurde darauf hingewiesen, dass bei fruchtlosem Fristablauf der' + ' Vermieter berechtigt ist, die Arbeiten durch Fachfirmen auf Kosten der Mieter durchführen zu lassen.',
    repairs_delegates_the_execution: ' Der Mieter beauftragt den Vermieter, die Mängel ',
    repairs_delegates_the_execution2: '. Der Mieter stimmt der Aufrechnung seiner' + ' Mietsicherheit zu. Die Mietsicherheit übersteigende Kosten trägt der Mieter.',
    repairs_budget_tenant: 'auf seine Kosten',
    repairs_budget_rent: 'gegen Aufrechnung',
    repairs_budget_rent2: 'mit der Mietsicherheit zu beseitigen bis zum',
    repairs_deadline: 'bis zum',
    tenant_refuses_to_eliminate: 'Der Mieter weigert sich, die Mängel zu beseitigen, weil',
    tenant_eliminate_defects_pays_sum: 'Der Mieter beteiligt sich an den Kosten der Mängelbeseitigung bis zur Höhe von',
    strange_text: 'Der Mieter wurde darauf hingewiesen, dass die Abgabe der Wohnungsschlüssel ohne Anerkennung einer Rechtspflicht im ' + 'Hinblick auf den Rückgabezustand der Wohnung erfolgt. Maßgebend ist das Protokoll der Bestandsaufnahme.',
    barter: 'Der Nachmieter stellt den Vormieter von seiner Mängelbeseitigungspflicht frei und erhält als Gegenleistung vom Vormieter',
    accept1: 'Der Nachmieter erkennt an, daß ihm die Mieträume in',
    accept2: 'Zustand übergeben wurden. Erkennbare Mängel an der Mietsache hat der Mieter innerhalb eines Monats nach Einzug schriftlich anzuzeigen. ',
    accept3: 'Mit dem Inhalt des Protokolls erkläre(n) ich/wir mich/uns einverstanden.',
    accept_amount_one: 'ich mich',
    accept_amount_some: 'wir uns',
    condition_perfect: 'mängelfreiem',
    condition_satisfactory: 'renoviertem',
    condition_agreement: 'vereinbartem',
    new_address: 'Neue Anschrift:',
    kontoverbindung: 'Kontoverbindung:',
    keys_header: 'Schlüssel',
    keys: {
      house: 'Haus',
      housing: 'Wohnungs',
      mailbox: 'Briefkasten',
      ground: 'Boden',
      vorkeller: 'Vorkeller',
      elevator: 'Keller',
      garages: 'Garagen',
      others: 'Sonstige'
    },
    footer_text: 'Schlüssel wurden heute übergeben.'
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);



/* harmony default export */ __webpack_exports__["a"] = ({
  imageToBase64: function imageToBase64(blob) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        resolve(reader.result);
      };
    });
  },
  createSignature: function createSignature() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', 'data:image/png;base64,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');

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolEditComponent_vue__ = __webpack_require__(602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a14b756_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolEditComponent_vue__ = __webpack_require__(911);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolEditComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a14b756_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolEditComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_state__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutations__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_getters__ = __webpack_require__(903);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__store_state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__store_mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__store_actions__["i" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_5__store_getters__["a" /* default */]
}));

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









/* harmony default export */ __webpack_exports__["a"] = ({
  getProtocolRequest: function getProtocolRequest(protocolId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_7_axios___default()({
                  url: 'protocols/' + protocolId,
                  method: 'GET'
                }).then(function (response) {
                  resolve(response.data.protocol);
                }).catch(function (error) {
                  reject(error.response.data);
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getProtocol: function getProtocol(protocolId) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', _this2.getProtocolRequest(protocolId));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  updateProtocol: function updateProtocol(protocol) {
    var _this3 = this;

    var sendMails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var rooms = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(protocol.rooms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var room = _step.value;

                    room.images_amount = 1;
                    rooms.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, room));
                    room.images = [];
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                __WEBPACK_IMPORTED_MODULE_7_axios___default()({
                  url: protocol.api_id !== undefined ? 'protocols/' + protocol.api_id : 'protocols',
                  data: {
                    date: protocol.date,
                    object: protocol.object,
                    street: protocol.street,
                    tenant: protocol.tenant,
                    signature_tenant: protocol.signature_tenant,
                    signature_inspector: protocol.signature_inspector,
                    signature_owner: protocol.signature_owner,
                    signature_old_tenant: protocol.signature_old_tenant,
                    protocol: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(protocol),
                    email_owner: protocol.email_owner,
                    email_old_tenant: protocol.email_old_tenant,
                    email_tenant: protocol.email_tenant,
                    email_inspector: protocol.email_inspector,
                    send_mails: sendMails
                  },
                  method: protocol.api_id !== undefined ? 'PUT' : 'POST'
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3(resp) {
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _this3.updateImages(resp.data.protocol.id, rooms, sendMails);

                          case 2:
                            resolve(resp.data.protocol.id);

                          case 3:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.log(error);
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  },
  updateImages: function updateImages(protocolId, rooms, sendMails) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
                  var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value, room, images;

                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _iteratorNormalCompletion2 = true;
                          _didIteratorError2 = false;
                          _iteratorError2 = undefined;
                          _context5.prev = 3;
                          _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_asyncIterator___default()(rooms);

                        case 5:
                          _context5.next = 7;
                          return _iterator2.next();

                        case 7:
                          _step2 = _context5.sent;
                          _iteratorNormalCompletion2 = _step2.done;
                          _context5.next = 11;
                          return _step2.value;

                        case 11:
                          _value = _context5.sent;

                          if (_iteratorNormalCompletion2) {
                            _context5.next = 22;
                            break;
                          }

                          room = _value;

                          if (!(room.images !== undefined)) {
                            _context5.next = 19;
                            break;
                          }

                          if (!(room.images.length > 0)) {
                            _context5.next = 19;
                            break;
                          }

                          images = room.images;
                          _context5.next = 19;
                          return __WEBPACK_IMPORTED_MODULE_7_axios___default()({
                            url: 'protocols/' + protocolId + '/' + room.id,
                            data: { images: images },
                            method: 'POST'
                          }).then(function (response) {}).catch(function (error) {
                            console.log(error);
                          });

                        case 19:
                          _iteratorNormalCompletion2 = true;
                          _context5.next = 5;
                          break;

                        case 22:
                          _context5.next = 28;
                          break;

                        case 24:
                          _context5.prev = 24;
                          _context5.t0 = _context5['catch'](3);
                          _didIteratorError2 = true;
                          _iteratorError2 = _context5.t0;

                        case 28:
                          _context5.prev = 28;
                          _context5.prev = 29;

                          if (!(!_iteratorNormalCompletion2 && _iterator2.return)) {
                            _context5.next = 33;
                            break;
                          }

                          _context5.next = 33;
                          return _iterator2.return();

                        case 33:
                          _context5.prev = 33;

                          if (!_didIteratorError2) {
                            _context5.next = 36;
                            break;
                          }

                          throw _iteratorError2;

                        case 36:
                          return _context5.finish(33);

                        case 37:
                          return _context5.finish(28);

                        case 38:
                          if (sendMails) {
                            _this4.sendMails(protocolId);
                          }
                          resolve();

                        case 40:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this4, [[3, 24, 28, 38], [29,, 33, 37]]);
                }));

                return function (_x3, _x4) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this4);
    }))();
  },
  sendMails: function sendMails(protocolId) {
    __WEBPACK_IMPORTED_MODULE_7_axios___default()({
      url: 'protocols/' + protocolId + '/mails/send',
      method: 'PUT'
    }).then(function (response) {
      return protocolId;
    }).catch(function (error) {
      return error;
    });
  }
});

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_images__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language_de__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions_idb__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var Protocol = function () {
  function Protocol() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Protocol);

    this.api_id = undefined;
    this.signature_owner = '';
    this.signature_tenant = '';
    this.signature_old_tenant = '';
    this.signature_inspector = '';
    this.email_owner = '';
    this.email_old_tenant = '';
    this.email_tenant = '';
    this.email_inspector = '';
    this.cause = {
      preliminary: false,
      final: false,
      state: false,
      transmission: false
    };
    this.floor = '';
    this.location = {
      left: '',
      right: '',
      middle: '',
      behind: '',
      hallway: '',
      vhs: '',
      hhs: ''
    };
    this.structure = {
      room: '',
      bathroom: '',
      restroom: '',
      kitchen: '',
      hallway: '',
      balcony: '',
      terrace: '',
      pantry: '',
      basement: '',
      basement_number: '',
      basement_number_number: '',
      attic: '',
      attic_number: '',
      garden: ''
    };
    this.furniture = {
      heating: {
        district: false,
        gas: false,
        central: false,
        other: false,
        other_value: ''
      },
      tv: {
        antenna: false,
        cable: false,
        satellite: false
      },
      other: {
        bicycle_storage: false,
        lift: false,
        intercom: false,
        shared_washing_machine: false,
        floor: false
      }
    };
    this.meters_data = {
      electricity_1: '',
      electricity_1_data: '',
      electricity_2: '',
      electricity_2_data: '',
      gas: '',
      gas_data: '',
      hot_water_1: '',
      cold_water_1: '',
      hot_water_2: '',
      cold_water_2: '',
      heat: '',
      intermediate_counter: ''
    };
    this.rooms = [{
      id: 0,
      name: __WEBPACK_IMPORTED_MODULE_5__language_de__["a" /* default */].protocol.rooms.kitchen,
      access: false,
      ceiling: '',
      walls: '',
      window: '',
      doors: '',
      radiator: '',
      radiator_value: '',
      plinth: '',
      floor: '',
      flooring: '',
      tenants_property: false,
      notes: false,
      notes_text: '',
      boiler_gas: false,
      boiler_flowing: false,
      boiler_electric: false,
      exist_boiler_other: false,
      boiler_other: '',
      equipment: '',
      material: '',
      tile: '',
      other: '',
      images: []
    }, {
      id: 1,
      name: __WEBPACK_IMPORTED_MODULE_5__language_de__["a" /* default */].protocol.rooms.bathroom,
      access: false,
      bathroom_set: false,
      ceiling: '',
      walls: '',
      window: '',
      doors: '',
      radiator: '',
      radiator_value: '',
      plinth: '',
      floor: '',
      bath: '',
      bath_structure: {
        freistehende: false,
        einbau: false,
        dusch: false,
        wc: false,
        bidet: false,
        spiegel: false
      },
      washbasin_structure: {
        waschbecken: false,
        ablage: false,
        handtuchhalter: false,
        papierhalter: false,
        duschkabine: false,
        wannenaufsatz: false
      },
      washbasin: '',
      material: '',
      wall_tile: '',
      wall_tile_structure: {
        wandfliesen: false,
        raumhoch: false,
        halbhoch: false,
        turhoch: false
      },
      tile: '',
      notes: false,
      notes_text: '',
      images: []
    }, {
      id: 2,
      name: __WEBPACK_IMPORTED_MODULE_5__language_de__["a" /* default */].protocol.rooms.hall,
      access: false,
      ceiling: '',
      walls: '',
      window: '',
      doors: '',
      radiator: '',
      radiator_value: '',
      plinth: '',
      floor: '',
      tenants_property: false,
      notes: false,
      notes_text: '',
      images: []
    }];
    this.object = '';
    this.basement_description = false;
    this.basement_description_text = '';
    this.balcony_description = false;
    this.balcony_description_text = '';
    this.tenant = '';
    this.remarks = '';
    this.maintenance_boiler_done = false;
    this.maintenance_boiler_not_done = false;
    this.maintenance_boiler_date = '';
    this.maintenance_boiler_executor_owner = false;
    this.warmly_pays = true;
    this.tenant_eliminate_defects = false;
    this.tenant_eliminate_defects_method = '';
    this.tenant_warned_of_deadline = false;
    this.repairs_delegates_the_execution = false;
    this.repairs_deadline = '';
    this.tenant_refuses_to_eliminate = false;
    this.strange_text = false;
    this.tenant_refuses_to_eliminate_reason = '';
    this.tenant_eliminate_defects_pays = false;
    this.tenant_eliminate_defects_pays_sum = '';
    this.barter = false;
    this.barter_text = '';
    this.accept = false;
    this.accept_amount = '';
    this.condition = __WEBPACK_IMPORTED_MODULE_5__language_de__["a" /* default */].protocol.condition_perfect;
    this.street = '';
    this.kontoverbindung = '';
    this.new_address = '';
    this.keys = {
      house: '',
      housing: '',
      mailbox: '',
      ground: '',
      vorkeller: '',
      elevator: '',
      garages: '',
      others: ''
    };
    this.notices = '';
    this.date = __WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date()).format('YYYY-MM-DD');
    this.repairs_budget = __WEBPACK_IMPORTED_MODULE_5__language_de__["a" /* default */].protocol.repairs_budget_tenant;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Protocol, [{
    key: 'createSignature',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__functions_images__["a" /* default */].createSignature();

              case 2:
                this.signature_owner = _context.sent;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__functions_images__["a" /* default */].createSignature();

              case 5:
                this.signature_tenant = _context.sent;
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4__functions_images__["a" /* default */].createSignature();

              case 8:
                this.signature_old_tenant = _context.sent;
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_4__functions_images__["a" /* default */].createSignature();

              case 11:
                this.signature_inspector = _context.sent;
                return _context.abrupt('return', this);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createSignature() {
        return _ref.apply(this, arguments);
      }

      return createSignature;
    }()
  }, {
    key: 'saveIdb',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__functions_idb__["a" /* default */].updateProtocol(this);

              case 2:
                id = _context2.sent;

                this.id = id;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveIdb() {
        return _ref2.apply(this, arguments);
      }

      return saveIdb;
    }()
  }, {
    key: 'copy',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newProtocol, key;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newProtocol = new Protocol();

                for (key in this) {
                  if (key !== 'id' && key !== 'api_id' && key !== 'signature_owner' && key !== 'signature_old_tenant' && key !== 'signature_tenant' && key !== 'signature_inspector') {
                    newProtocol[key] = this[key];
                  }
                }
                _context3.next = 4;
                return newProtocol.createSignature();

              case 4:
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__functions_idb__["a" /* default */].updateProtocol(newProtocol);

              case 6:
                newProtocol.id = _context3.sent;
                return _context3.abrupt('return', newProtocol);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function copy() {
        return _ref3.apply(this, arguments);
      }

      return copy;
    }()
  }, {
    key: 'init',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(protocol) {
        var key;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                for (key in protocol) {
                  this[key] = protocol[key];
                }
                return _context4.abrupt('return', this);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function init(_x) {
        return _ref4.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__functions_idb__["a" /* default */].deleteProtocol(this);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete() {
        return _ref5.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return Protocol;
}();

/* harmony default export */ __webpack_exports__["a"] = (Protocol);

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(105);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  mounted: function mounted() {
    if (this.$store.getters.isAuthenticated) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_actions__["g" /* USER_SUCCESS */], JSON.parse(localStorage.getItem('user')));
      this.is_user_admin = this.$store.getters.hasRole('admin');
    }
  },
  data: function data() {
    return {
      online: navigator.onLine,
      is_user_admin: true,
      auth: this.$store.getters.isAuthenticated,
      version: '2.5'
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_3__store_actions__["b" /* AUTH_LOGOUT */]]), {
    logout: function logout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.AUTH_LOGOUT();

              case 2:
                _context.next = 4;
                return _this.$router.push({ name: 'Login' });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_protocols_ProtocolEditComponent__ = __webpack_require__(256);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocalProtocolNew',
  components: { ProtocolEditComponent: __WEBPACK_IMPORTED_MODULE_0__components_protocols_ProtocolEditComponent__["a" /* default */] }
});

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_protocol__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_de__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__functions_api__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__functions_idb__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__functions_images__ = __webpack_require__(255);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProtocolEditComponent',
  props: ['new', 'local', 'id'],
  data: function data() {
    return {
      api_id: undefined,
      local_id: undefined,
      protocol: new __WEBPACK_IMPORTED_MODULE_5__classes_protocol__["a" /* default */](),
      trans: __WEBPACK_IMPORTED_MODULE_6__language_de__["a" /* default */],
      images: __WEBPACK_IMPORTED_MODULE_10__functions_images__["a" /* default */],
      modal_image: '',
      download_data: false,
      await_spinner: false,
      delete_room_index: ''
    };
  },

  watch: {
    protocol: {
      handler: function handler() {
        if (this.local) {
          this.protocol.saveIdb();
        }
      },

      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var result;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.local = _this.$route.path.indexOf('local') > -1;

              if (!(_this.$store.getters.getCurrentProtocol.update_signature !== undefined && _this.$store.getters.getCurrentProtocol.update_signature)) {
                _context.next = 11;
                break;
              }

              _context.t0 = _this.protocol;
              _context.next = 5;
              return _this.$store.getters.getCurrentProtocol;

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return _context.t0.init.call(_context.t0, _context.t1);

            case 8:
              _this.protocol = _context.sent;
              _context.next = 25;
              break;

            case 11:
              if (!_this.new) {
                _context.next = 19;
                break;
              }

              _context.next = 14;
              return _this.protocol.saveIdb();

            case 14:
              _context.next = 16;
              return _this.protocol.createSignature();

            case 16:
              _this.protocol = _context.sent;
              _context.next = 25;
              break;

            case 19:
              _context.next = 21;
              return _this.getProtocol({ id: _this.$route.params.id, local: _this.local });

            case 21:
              result = _context.sent;
              _context.next = 24;
              return _this.protocol.init(result);

            case 24:
              _this.protocol = _context.sent;

            case 25:
              _this.$store.commit('SET_PROTOCOL', { protocol: _this.protocol });
              _this.download_data = true;
              _this.$nextTick(function () {
                var elem = document.querySelector('.img-fluid');
                if (elem !== undefined) {
                  _this.loadSignature();
                }
              });

            case 28:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['newProtocol', 'getProtocol']), {
    save: function save(sendMails) {
      var _this2 = this;

      var redirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.await_spinner = true;
                _this2.download_data = false;
                _this2.protocol.draft = false;

                if (!navigator.onLine) {
                  _context2.next = 42;
                  break;
                }

                _context2.prev = 4;
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_8__functions_api__["a" /* default */].updateProtocol(_this2.protocol, sendMails);

              case 7:
                response = _context2.sent;
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__functions_idb__["a" /* default */].deleteProtocol(_this2.protocol);

              case 10:
                if (!redirect) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 13;
                return _this2.$router.push({ name: 'ApiProtocols' });

              case 13:
                _context2.next = 27;
                break;

              case 15:
                if (!(_this2.$route.name === 'ApiProtocolEdit')) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 18;
                return _this2.getProtocol({ id: response, local: false });

              case 18:
                result = _context2.sent;
                _context2.next = 21;
                return _this2.protocol.init(result);

              case 21:
                _this2.protocol = _context2.sent;

                _this2.await_spinner = false;
                _context2.next = 27;
                break;

              case 25:
                _context2.next = 27;
                return _this2.$router.push('/protocols/' + response);

              case 27:
                _context2.next = 40;
                break;

              case 29:
                _context2.prev = 29;
                _context2.t0 = _context2['catch'](4);

                console.log(_context2.t0);
                _context2.next = 34;
                return __WEBPACK_IMPORTED_MODULE_9__functions_idb__["a" /* default */].updateProtocol(_this2.protocol);

              case 34:
                if (!redirect) {
                  _context2.next = 39;
                  break;
                }

                _context2.next = 37;
                return _this2.$router.push({ name: 'LocalProtocols' });

              case 37:
                _context2.next = 40;
                break;

              case 39:
                _this2.await_spinner = false;

              case 40:
                _context2.next = 50;
                break;

              case 42:
                _context2.next = 44;
                return __WEBPACK_IMPORTED_MODULE_9__functions_idb__["a" /* default */].updateProtocol(_this2.protocol);

              case 44:
                if (!redirect) {
                  _context2.next = 49;
                  break;
                }

                _context2.next = 47;
                return _this2.$router.push({ name: 'LocalProtocols' });

              case 47:
                _context2.next = 50;
                break;

              case 49:
                _this2.await_spinner = false;

              case 50:
                _this2.download_data = true;

              case 51:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 29]]);
      }))();
    },
    copy: function copy() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newProtocol;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.await_spinner = true;
                _context3.next = 3;
                return _this3.protocol.copy();

              case 3:
                newProtocol = _context3.sent;
                _context3.next = 6;
                return _this3.$router.push('/local/protocols/' + newProtocol.id);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    back: function back() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.await_spinner = true;
                _context4.next = 3;
                return _this4.protocol.delete();

              case 3:
                _context4.next = 5;
                return _this4.$router.push({ name: 'ApiProtocols' });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    signatureEdit: function signatureEdit(subject) {
      this.$store.commit('SET_PROTOCOL', { protocol: this.protocol });
      this.$router.push({ name: 'Signature', params: { subject: subject } });
    },
    loadSignature: function loadSignature() {
      if (this.protocol.update_signature) {
        window.scrollTo(0, document.body.scrollHeight);
      }
      this.protocol.update_signature = false;
    },
    addRoom: function addRoom() {
      var room = {
        id: this.protocol.rooms.length,
        name: this.$trans.protocol.rooms.room + ' ' + (this.protocol.rooms.length - 2),
        access: false,
        ceiling: '',
        walls: '',
        window: '',
        doors: '',
        radiator: '',
        radiator_value: '',
        plinth: '',
        floor: '',
        tenants_property: false,
        notes: false,
        notes_text: '',
        images: []
      };
      this.protocol.rooms.push(room);
      this.$nextTick(function () {
        var elem = document.getElementById('room_name_' + (room.id + 1));
        if (elem !== undefined) {
          elem.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      });
    },
    deleteRoom: function deleteRoom() {
      this.protocol.rooms.splice(this.delete_room_index, 1);
    },
    filesChange: function filesChange(file, roomIndex) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var htmlImage, fileLink, imageRoom;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.newHtmlImage(file);

              case 2:
                htmlImage = _context5.sent;
                fileLink = document.createElement('a');

                fileLink.href = htmlImage.src;
                fileLink.setAttribute('download', Date.now() + '.jpg');
                document.body.appendChild(fileLink);
                fileLink.click();
                _context5.t0 = _this5.images;
                _context5.next = 11;
                return _this5.saveImageMin(htmlImage);

              case 11:
                _context5.t1 = _context5.sent;
                _context5.next = 14;
                return _context5.t0.imageToBase64.call(_context5.t0, _context5.t1);

              case 14:
                _context5.t2 = _context5.sent;
                _context5.t3 = {
                  blob: _context5.t2
                };
                _context5.t4 = _this5.images;
                _context5.next = 19;
                return _this5.saveImage(htmlImage);

              case 19:
                _context5.t5 = _context5.sent;
                _context5.next = 22;
                return _context5.t4.imageToBase64.call(_context5.t4, _context5.t5);

              case 22:
                _context5.t6 = _context5.sent;
                _context5.t7 = {
                  blob: _context5.t6
                };
                imageRoom = {
                  small: _context5.t3,
                  main: _context5.t7
                };

                _this5.protocol.rooms[roomIndex].images.push(imageRoom);

              case 26:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    deleteImage: function deleteImage(roomId, imageId) {
      this.protocol.rooms[roomId].images.splice(imageId, 1);
    },
    openBigImage: function openBigImage(image) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.modal_image = image.main.blob;
                _this6.$bvModal.show('modal-big-image');

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    newHtmlImage: function newHtmlImage(file) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var img = new Image();
                  img.src = URL.createObjectURL(file);
                  img.onload = function () {
                    resolve(img);
                  };
                }));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },

    getPdf: function getPdf() {
      var _this8 = this;

      this.await_spinner = true;
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({
        url: 'protocols/' + this.$route.params.id + '/pdf',
        method: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Protokoll' + _this8.$route.params.id + '.pdf');
        document.body.appendChild(fileLink);

        fileLink.click();
        _this8.await_spinner = false;
      });
    },
    saveImage: function saveImage(image) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var height = 512;
        var scaleFactor = height / image.height;
        canvas.width = image.width * scaleFactor;
        canvas.height = height;
        context.drawImage(image, 0, 0, image.width * scaleFactor, height);
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, 'image/jpeg', 0.80);
      });
    },
    saveImageMin: function saveImageMin(image) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        var width = 120;
        var scaleFactor = width / image.width;
        canvas.width = width;
        canvas.height = image.height * scaleFactor;

        context.drawImage(image, 0, 0, width, image.height * scaleFactor);
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, 'image/jpeg', 0.80);
      });
    }
  })
});

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocalProtocols',
  props: {
    local: Boolean
  },
  data: function data() {
    return {
      protocols: [],
      deleted_protocol: {},
      warning_modal: false,
      moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a
    };
  },
  created: function created() {
    var _this = this;

    this.getProtocols({ local: true }).then(function (result) {
      _this.protocols = result;
    }, function (error) {
      console.log(error);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getProtocols', 'deleteProtocolFromIdb', 'saveProtocol']), {
    deleteProtocol: function deleteProtocol(protocol) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.deleteProtocolFromIdb({ protocol: protocol });

              case 2:
                _this2.getProtocols({ local: true }).then(function (result) {
                  _this2.protocols = result;
                }, function (error) {
                  console.log(error);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    deleteProtocolWarning: function deleteProtocolWarning(protocol) {
      this.deleted_protocol = protocol;
      this.$bvModal.show('delete_modal');
      this.warning_modal = true;
    },
    editProtocol: function editProtocol(protocol) {
      this.$router.push({ name: 'LocalProtocolEdit', params: { id: protocol.id } });
    },
    synchronize: function synchronize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, protocol;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.protocols);

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 13;
                  break;
                }

                protocol = _step.value;

                if (protocol.draft) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return _this3.saveProtocol({ protocol: protocol, local: false }).then(function (result) {}, function (error) {
                  console.log(error);
                });

              case 10:
                _iteratorNormalCompletion = true;
                _context2.next = 5;
                break;

              case 13:
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 19:
                _context2.prev = 19;
                _context2.prev = 20;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 22:
                _context2.prev = 22;

                if (!_didIteratorError) {
                  _context2.next = 25;
                  break;
                }

                throw _iteratorError;

              case 25:
                return _context2.finish(22);

              case 26:
                return _context2.finish(19);

              case 27:
                _this3.getProtocols({ local: true }).then(function (result) {
                  _this3.protocols = result;
                }, function (error) {
                  console.log(error);
                });

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 15, 19, 27], [20,, 22, 26]]);
      }))();
    }
  })
});

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_protocols_ProtocolEditComponent__ = __webpack_require__(256);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocalProtocolEdit',
  components: { ProtocolEditComponent: __WEBPACK_IMPORTED_MODULE_0__components_protocols_ProtocolEditComponent__["a" /* default */] }
});

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_idb__ = __webpack_require__(160);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocalProtocols',
  data: function data() {
    return {
      protocols: [],
      page: 1,
      filters: {
        date: ''
      },
      is_user_admin: this.$store.getters.hasRole('admin'),
      pages: [],
      deleted_protocol: {},
      warning_modal: false,
      protocol_isset: false,
      local_protocol: {},
      api_protocol_id: '',
      moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a
    };
  },

  watch: {
    page: function page() {
      this.getProtocols();
    }
  },
  created: function created() {
    this.getProtocols();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['deleteProtocolFromIdb', 'getProtocolWhereApiID']), {
    deleteProtocol: function deleteProtocol(protocol) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                    url: 'protocols/' + protocol.id,
                    method: 'DELETE'
                  }).then(function (response) {
                    _this.getProtocols();
                  }).catch(function (error) {
                    console.log(error.response.data);
                  });
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    deleteProtocolWarning: function deleteProtocolWarning(protocol) {
      this.deleted_protocol = protocol;
      this.$bvModal.show('delete_modal');
      this.warning_modal = true;
    },
    getProtocols: function getProtocols() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                    url: 'protocols',
                    params: { filters: _this2.filters, page: _this2.page },
                    method: 'GET'
                  }).then(function (response) {
                    _this2.protocols = response.data.protocols.data;
                    _this2.page = response.data.protocols.current_page;
                    var maxPage = Math.ceil(response.data.protocols.total / response.data.protocols.per_page);
                    _this2.pages = [];
                    for (var i = 1; i <= maxPage; i++) {
                      _this2.pages.push(i);
                    }
                  }).catch(function (error) {
                    console.log(error.response.data);
                  });
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    editProtocol: function editProtocol(protocol) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var localProtocols, id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getProtocolWhereApiID(protocol.id);

              case 2:
                localProtocols = _context3.sent;

                if (!(localProtocols.length > 0)) {
                  _context3.next = 10;
                  break;
                }

                _this3.local_protocol = localProtocols[0];
                _this3.api_protocol_id = protocol.id;
                _this3.protocol_isset = true;
                _this3.$bvModal.show('modal_protocol_isset');
                _context3.next = 13;
                break;

              case 10:
                id = protocol.id;
                _context3.next = 13;
                return _this3.$router.push({ name: 'ApiProtocolEdit', params: { id: id } });

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    deleteLocalProtocol: function deleteLocalProtocol() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__functions_idb__["a" /* default */].deleteProtocol(_this4.local_protocol);

              case 2:
                id = _this4.api_protocol_id;
                _context4.next = 5;
                return _this4.$router.push({ name: 'ApiProtocolEdit', params: { id: id } });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    editLocalProtocol: function editLocalProtocol() {
      var localProtocol = this.local_protocol;
      this.$router.push({ name: 'LocalProtocolEdit', params: { id: localProtocol.id } });
    }
  })
});

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_protocols_ProtocolEditComponent__ = __webpack_require__(256);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ApiProtocolEdit',
  components: { ProtocolEditComponent: __WEBPACK_IMPORTED_MODULE_0__components_protocols_ProtocolEditComponent__["a" /* default */] }
});

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_images__ = __webpack_require__(255);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Canvas',
  data: function data() {
    return {
      ctx: null,
      painting: false,
      offsetCanvas: { top: 0, left: 0 },
      canvas_width: 400,
      canvas_height: 180,
      protocol: {},
      canvas_id: 'id',
      images: __WEBPACK_IMPORTED_MODULE_5__functions_images__["a" /* default */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$refs.canvas.width = _this.canvas_width;
              _this.$refs.canvas.height = _this.canvas_height;
              _context.next = 4;
              return _this.$store.getters.getCurrentProtocol;

            case 4:
              _this.protocol = _context.sent;

              _this.offsetCanvas = _this.getOffsetRect();
              _this.canvas_id = 'canvas' + _this.protocol.id + _this.$route.params.subject;
              _this.init();

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['getProtocol', 'saveProtocol']), {
    init: function init() {
      this.setCtx();
      if (this.protocol[this.$route.params.subject] !== '') {
        var img = new Image();
        var ctx = this.ctx;
        img.onload = function () {
          ctx.drawImage(img, 0, 0);
        };
        img.src = this.protocol[this.$route.params.subject];
      }
    },
    setCtx: function setCtx() {
      this.$refs.canvas.getContext('2d').clearRect(0, 0, this.canvas_width, this.canvas_height);
      this.ctx = this.$refs.canvas.getContext('2d');
      this.ctx.lineWidth = 5;
      this.ctx.lineCap = 'round';
      this.ctx.strokeStyle = 'blue';
    },
    start: function start(e) {
      this.painting = true;
      this.ctx.beginPath();
    },
    finish: function finish(e) {
      this.painting = false;
    },
    draw: function draw(e) {
      if (this.painting) {
        e = this.getTouchPos(e);
        this.stroke(e);
        this.ctx.beginPath();
        this.ctx.moveTo(e.offsetX, e.offsetY);
      }
    },
    stroke: function stroke(e) {
      this.ctx.lineTo(e.offsetX, e.offsetY);
      this.ctx.stroke();
    },
    getTouchPos: function getTouchPos(e) {
      if (e.touches) {
        this.offsetCanvas = this.getOffsetRect();
        var touch = e.touches[0];
        var touchX = touch.pageX - this.offsetCanvas.left;
        var touchY = touch.pageY - this.offsetCanvas.top;
        return { offsetX: touchX, offsetY: touchY };
      } else {
        return { offsetX: e.offsetX, offsetY: e.offsetY };
      }
    },
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.saveSignature(_this2.$refs.canvas);

              case 2:
                _this2.protocol[_this2.$route.params.subject] = _context2.sent;
                _context2.next = 5;
                return _this2.images.imageToBase64(_this2.protocol[_this2.$route.params.subject]);

              case 5:
                _this2.protocol[_this2.$route.params.subject] = _context2.sent;

                _this2.protocol.update_signature = true;
                _this2.$store.commit('SET_PROTOCOL', { protocol: _this2.protocol });
                return _context2.abrupt('return', _this2.$router.back());

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    back: function back() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.protocol.update_signature = true;
                _this3.$store.commit('SET_PROTOCOL', { protocol: _this3.protocol });
                return _context3.abrupt('return', _this3.$router.back());

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    saveSignature: function saveSignature(canvas) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, 'image/png');
      });
    },
    getOffsetRect: function getOffsetRect() {
      var elem = document.getElementById(this.canvas_id);
      var box = elem.getBoundingClientRect();

      var body = document.body;
      var docElem = document.documentElement;

      var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
      var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

      var clientTop = docElem.clientTop || body.clientTop || 0;
      var clientLeft = docElem.clientLeft || body.clientLeft || 0;

      var top = box.top + scrollTop - clientTop;
      var left = box.left + scrollLeft - clientLeft;

      return { top: Math.round(top), left: Math.round(left) };
    }
  })
});

/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_de__ = __webpack_require__(162);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      login: '',
      password: '',
      errors: false,
      error: '',
      trans: __WEBPACK_IMPORTED_MODULE_1__language_de__["a" /* default */]
    };
  },
  mounted: function mounted() {},

  methods: {
    focusPasswordInput: function focusPasswordInput() {
      document.getElementById('input_password').focus();
    },

    auth: function auth() {
      var _this = this;

      this.errors = false;
      var login = this.login,
          password = this.password;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_actions__["c" /* AUTH_REQUEST */], { login: login, password: password }).then(function (resp) {
        _this.$router.push('/');
      }).catch(function (err) {
        _this.error = err;
        _this.errors = true;
      });
    }
  }
});

/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocalUsers',
  data: function data() {
    return {
      users: [],
      page: 1,
      filters: {
        date: ''
      },
      pages: []
    };
  },

  watch: {
    page: function page() {
      this.getUsers();
    }
  },
  created: function created() {
    this.getUsers();
  },

  methods: {
    deleteUser: function deleteUser(user) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                  url: 'users/' + user.id,
                  method: 'DELETE'
                }).then(function (response) {
                  _this.getUsers();
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getUsers: function getUsers() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                    url: 'users',
                    params: { filters: _this2.filters, page: _this2.page },
                    method: 'GET'
                  }).then(function (response) {
                    _this2.users = response.data.users.data;
                    _this2.page = response.data.users.current_page;
                    var maxPage = Math.ceil(response.data.users.total / response.data.users.per_page);
                    _this2.pages = [];
                    for (var i = 1; i <= maxPage; i++) {
                      _this2.pages.push(i);
                    }
                  }).catch(function (error) {
                    console.log(error.response.data);
                  });
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    editUser: function editUser(user) {
      var id = user.id;
      this.$router.push({ name: 'UserEdit', params: { id: id } });
    }
  }
});

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocalUsers',
  data: function data() {
    return {
      user: {
        id: '',
        name: '',
        login: '',
        password: ''
      }
    };
  },
  created: function created() {
    this.getUser();
  },

  methods: {
    deleteUser: function deleteUser() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                  url: 'users/' + _this.user.id,
                  method: 'DELETE'
                }).then(function (response) {
                  _this.getUsers();
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    newPassword: function newPassword() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                  url: 'users/' + _this2.user.id + '/password',
                  data: { password: _this2.user.password },
                  method: 'PUT'
                }).then(function (response) {
                  _this2.$router.back();
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    change: function change() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                  url: 'users/' + _this3.user.id,
                  data: {
                    login: _this3.user.login,
                    name: _this3.user.name,
                    type: _this3.user.type
                  },
                  method: 'PUT'
                }).then(function (response) {
                  _this3.$router.back();
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getUser: function getUser() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                    url: 'users/' + _this4.$route.params.id,
                    method: 'GET'
                  }).then(function (response) {
                    _this4.user = response.data.user;
                  }).catch(function (error) {
                    console.log(error.response.data);
                  });
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocalUsers',
  data: function data() {
    return {
      user: {
        name: '',
        login: '',
        password: '',
        type: 'user'
      }
    };
  },
  created: function created() {},

  methods: {
    change: function change() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                  url: 'users/',
                  data: {
                    login: _this.user.login,
                    name: _this.user.name,
                    password: _this.user.password,
                    type: _this.user.type
                  },
                  method: 'POST'
                }).then(function (response) {
                  _this.$router.back();
                }).catch(function (error) {
                  console.log(error.response.data);
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mutationobserver_shim__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mutationobserver_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mutationobserver_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_bootstrap_vue__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_moment__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_axios__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_touch_events__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__language_de__ = __webpack_require__(162);













__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$trans = __WEBPACK_IMPORTED_MODULE_10__language_de__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters.isAuthenticated && to.path !== '/login') {
    next();
  } else if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters.isAuthenticated && to.path === '/login') {
    next('/');
  } else if (!__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters.isAuthenticated && to.path === '/login') {
    next();
  } else {
    next('/login');
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_6_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  template: '<App/>',
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */] }
});

/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_custom_css__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_custom_css__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 830:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_momentjs__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_momentjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_momentjs__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_momentjs___default.a, __WEBPACK_IMPORTED_MODULE_1_moment___default.a);

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 435,
	"./af.js": 435,
	"./ar": 436,
	"./ar-dz": 437,
	"./ar-dz.js": 437,
	"./ar-kw": 438,
	"./ar-kw.js": 438,
	"./ar-ly": 439,
	"./ar-ly.js": 439,
	"./ar-ma": 440,
	"./ar-ma.js": 440,
	"./ar-sa": 441,
	"./ar-sa.js": 441,
	"./ar-tn": 442,
	"./ar-tn.js": 442,
	"./ar.js": 436,
	"./az": 443,
	"./az.js": 443,
	"./be": 444,
	"./be.js": 444,
	"./bg": 445,
	"./bg.js": 445,
	"./bm": 446,
	"./bm.js": 446,
	"./bn": 447,
	"./bn-bd": 448,
	"./bn-bd.js": 448,
	"./bn.js": 447,
	"./bo": 449,
	"./bo.js": 449,
	"./br": 450,
	"./br.js": 450,
	"./bs": 451,
	"./bs.js": 451,
	"./ca": 452,
	"./ca.js": 452,
	"./cs": 453,
	"./cs.js": 453,
	"./cv": 454,
	"./cv.js": 454,
	"./cy": 455,
	"./cy.js": 455,
	"./da": 456,
	"./da.js": 456,
	"./de": 457,
	"./de-at": 458,
	"./de-at.js": 458,
	"./de-ch": 459,
	"./de-ch.js": 459,
	"./de.js": 457,
	"./dv": 460,
	"./dv.js": 460,
	"./el": 461,
	"./el.js": 461,
	"./en-au": 462,
	"./en-au.js": 462,
	"./en-ca": 463,
	"./en-ca.js": 463,
	"./en-gb": 464,
	"./en-gb.js": 464,
	"./en-ie": 465,
	"./en-ie.js": 465,
	"./en-il": 466,
	"./en-il.js": 466,
	"./en-in": 467,
	"./en-in.js": 467,
	"./en-nz": 468,
	"./en-nz.js": 468,
	"./en-sg": 469,
	"./en-sg.js": 469,
	"./eo": 470,
	"./eo.js": 470,
	"./es": 471,
	"./es-do": 472,
	"./es-do.js": 472,
	"./es-mx": 473,
	"./es-mx.js": 473,
	"./es-us": 474,
	"./es-us.js": 474,
	"./es.js": 471,
	"./et": 475,
	"./et.js": 475,
	"./eu": 476,
	"./eu.js": 476,
	"./fa": 477,
	"./fa.js": 477,
	"./fi": 478,
	"./fi.js": 478,
	"./fil": 479,
	"./fil.js": 479,
	"./fo": 480,
	"./fo.js": 480,
	"./fr": 481,
	"./fr-ca": 482,
	"./fr-ca.js": 482,
	"./fr-ch": 483,
	"./fr-ch.js": 483,
	"./fr.js": 481,
	"./fy": 484,
	"./fy.js": 484,
	"./ga": 485,
	"./ga.js": 485,
	"./gd": 486,
	"./gd.js": 486,
	"./gl": 487,
	"./gl.js": 487,
	"./gom-deva": 488,
	"./gom-deva.js": 488,
	"./gom-latn": 489,
	"./gom-latn.js": 489,
	"./gu": 490,
	"./gu.js": 490,
	"./he": 491,
	"./he.js": 491,
	"./hi": 492,
	"./hi.js": 492,
	"./hr": 493,
	"./hr.js": 493,
	"./hu": 494,
	"./hu.js": 494,
	"./hy-am": 495,
	"./hy-am.js": 495,
	"./id": 496,
	"./id.js": 496,
	"./is": 497,
	"./is.js": 497,
	"./it": 498,
	"./it-ch": 499,
	"./it-ch.js": 499,
	"./it.js": 498,
	"./ja": 500,
	"./ja.js": 500,
	"./jv": 501,
	"./jv.js": 501,
	"./ka": 502,
	"./ka.js": 502,
	"./kk": 503,
	"./kk.js": 503,
	"./km": 504,
	"./km.js": 504,
	"./kn": 505,
	"./kn.js": 505,
	"./ko": 506,
	"./ko.js": 506,
	"./ku": 507,
	"./ku.js": 507,
	"./ky": 508,
	"./ky.js": 508,
	"./lb": 509,
	"./lb.js": 509,
	"./lo": 510,
	"./lo.js": 510,
	"./lt": 511,
	"./lt.js": 511,
	"./lv": 512,
	"./lv.js": 512,
	"./me": 513,
	"./me.js": 513,
	"./mi": 514,
	"./mi.js": 514,
	"./mk": 515,
	"./mk.js": 515,
	"./ml": 516,
	"./ml.js": 516,
	"./mn": 517,
	"./mn.js": 517,
	"./mr": 518,
	"./mr.js": 518,
	"./ms": 519,
	"./ms-my": 520,
	"./ms-my.js": 520,
	"./ms.js": 519,
	"./mt": 521,
	"./mt.js": 521,
	"./my": 522,
	"./my.js": 522,
	"./nb": 523,
	"./nb.js": 523,
	"./ne": 524,
	"./ne.js": 524,
	"./nl": 525,
	"./nl-be": 526,
	"./nl-be.js": 526,
	"./nl.js": 525,
	"./nn": 527,
	"./nn.js": 527,
	"./oc-lnc": 528,
	"./oc-lnc.js": 528,
	"./pa-in": 529,
	"./pa-in.js": 529,
	"./pl": 530,
	"./pl.js": 530,
	"./pt": 531,
	"./pt-br": 532,
	"./pt-br.js": 532,
	"./pt.js": 531,
	"./ro": 533,
	"./ro.js": 533,
	"./ru": 534,
	"./ru.js": 534,
	"./sd": 535,
	"./sd.js": 535,
	"./se": 536,
	"./se.js": 536,
	"./si": 537,
	"./si.js": 537,
	"./sk": 538,
	"./sk.js": 538,
	"./sl": 539,
	"./sl.js": 539,
	"./sq": 540,
	"./sq.js": 540,
	"./sr": 541,
	"./sr-cyrl": 542,
	"./sr-cyrl.js": 542,
	"./sr.js": 541,
	"./ss": 543,
	"./ss.js": 543,
	"./sv": 544,
	"./sv.js": 544,
	"./sw": 545,
	"./sw.js": 545,
	"./ta": 546,
	"./ta.js": 546,
	"./te": 547,
	"./te.js": 547,
	"./tet": 548,
	"./tet.js": 548,
	"./tg": 549,
	"./tg.js": 549,
	"./th": 550,
	"./th.js": 550,
	"./tk": 551,
	"./tk.js": 551,
	"./tl-ph": 552,
	"./tl-ph.js": 552,
	"./tlh": 553,
	"./tlh.js": 553,
	"./tr": 554,
	"./tr.js": 554,
	"./tzl": 555,
	"./tzl.js": 555,
	"./tzm": 556,
	"./tzm-latn": 557,
	"./tzm-latn.js": 557,
	"./tzm.js": 556,
	"./ug-cn": 558,
	"./ug-cn.js": 558,
	"./uk": 559,
	"./uk.js": 559,
	"./ur": 560,
	"./ur.js": 560,
	"./uz": 561,
	"./uz-latn": 562,
	"./uz-latn.js": 562,
	"./uz.js": 561,
	"./vi": 563,
	"./vi.js": 563,
	"./x-pseudo": 564,
	"./x-pseudo.js": 564,
	"./yo": 565,
	"./yo.js": 565,
	"./zh-cn": 566,
	"./zh-cn.js": 566,
	"./zh-hk": 567,
	"./zh-hk.js": 567,
	"./zh-mo": 568,
	"./zh-mo.js": 568,
	"./zh-tw": 569,
	"./zh-tw.js": 569
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 833;

/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions__ = __webpack_require__(120);








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

window.axios = __webpack_require__(67);
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = "https://protokoll-api-dev.ak-immobilien.info";
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(undefined, function (error) {
  if (error.response && error.response.status === 401) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions__["a" /* AUTH_ERROR */]).then(function () {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('modalAuthError', true);
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var token = localStorage.getItem('user-token');
if (token) {
  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = token;
}

/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  protocol: {},
  status: '',
  profile: {},
  token: localStorage.getItem('user-token') || ''
});

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions__ = __webpack_require__(120);


var _SET_PROTOCOL$modalAu;




/* harmony default export */ __webpack_exports__["a"] = (_SET_PROTOCOL$modalAu = {
  SET_PROTOCOL: function SET_PROTOCOL(state, _ref) {
    var protocol = _ref.protocol;

    state.protocol = protocol;
  },

  modalAuthError: function modalAuthError(state, item) {
    state.modalAuthError = item;
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["f" /* USER_REQUEST */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["g" /* USER_SUCCESS */], function (state, resp) {
  state.status = 'success';
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'profile', resp);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["h" /* USER_UPDATE */], function (state, resp) {
  state.status = 'success';
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'profile', resp);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["e" /* USER_ERROR */], function (state) {
  state.status = 'error';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["b" /* AUTH_LOGOUT */], function (state) {
  state.profile = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["c" /* AUTH_REQUEST */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["d" /* AUTH_SUCCESS */], function (state, token) {
  state.status = 'success';
  state.token = token;
  state.hasLoadedOnce = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["a" /* AUTH_ERROR */], function (state) {
  state.status = 'error';
  state.hasLoadedOnce = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PROTOCOL$modalAu, __WEBPACK_IMPORTED_MODULE_2__store_actions__["b" /* AUTH_LOGOUT */], function (state) {
  state.token = '';
}), _SET_PROTOCOL$modalAu);

/***/ }),

/***/ 903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getCurrentProtocol: function getCurrentProtocol(state) {
    return state.protocol;
  },
  hasRole: function hasRole(state) {
    return function (role) {
      if (state.profile.type !== undefined) {
        return state.profile.type.indexOf(role) > -1;
      } else {
        return false;
      }
    };
  },
  getProfile: function getProfile(state) {
    return state.profile;
  },
  isAuthenticated: function isAuthenticated(state) {
    return !!state.token;
  }
});

/***/ }),

/***/ 904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_touch_events__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_touch_events__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue2_touch_events___default.a);

/***/ }),

/***/ 906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(600);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6b3638e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(907);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6b3638e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.isAuthenticated)?_c('header',{staticClass:"top-row"},[_c('div',[_c('b-navbar',{staticClass:"bg-dark",attrs:{"toggleable":"sm","type":"dark","variant":"info"}},[_c('b-navbar-brand',{class:_vm.online ? '' : 'text-danger',attrs:{"href":"#"}},[_c('img',{staticStyle:{"width":"55px","height":"55px","margin":"-10px 0 -10px -14px"},attrs:{"src":"static/img/logo.png","alt":"Logo"}}),_vm._v(" "),_c('b',{staticStyle:{"font-size":"12px"}},[_vm._v(" "+_vm._s('v' + _vm.version))]),_vm._v("\n          "+_vm._s(_vm.online ? ' Online' : ' Offline')+"\n        ")]),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"active":_vm.$route.name.indexOf('Local') > -1 || _vm.$route.name === 'ProtocolNew'},on:{"click":function($event){return _vm.$router.push({name: 'LocalProtocols'})}}},[_vm._v("\n              "+_vm._s(_vm.$trans.main.out_of_sync)+"\n            ")]),_vm._v(" "),_c('b-nav-item',{attrs:{"active":_vm.$route.name.indexOf('ApiProtocol') > -1},on:{"click":function($event){return _vm.$router.push({name: 'ApiProtocols'})}}},[_vm._v("\n              "+_vm._s(_vm.$trans.main.protocols)+"\n            ")]),_vm._v(" "),(_vm.is_user_admin)?_c('b-nav-item',{attrs:{"active":_vm.$route.name.indexOf('Users') > -1},on:{"click":function($event){return _vm.$router.push({name: 'Users'})}}},[_vm._v("\n              "+_vm._s(_vm.$trans.users)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.is_user_admin)?_c('b-nav-item',{on:{"click":function($event){return _vm.logout()}}},[_vm._v("\n              "+_vm._s(_vm.$trans.main.button_logout)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-form',[(!['ProtocolNew', 'LocalProtocolEdit', 'ApiProtocolEdit'].includes(_vm.$route.name))?_c('b-button',{staticClass:"my-2 my-sm-0 btn-success",attrs:{"size":"sm"},on:{"click":function($event){return _vm.$router.push({name: 'ProtocolNew'})}}},[_vm._v("\n                "+_vm._s(_vm.$trans.main.button_add)+"\n              ")]):_vm._e()],1)],1)],1)],1)],1)]):_vm._e(),_vm._v(" "),_c('main',{staticClass:"py-5 mb-5",attrs:{"role":"main"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_vm._v(" "),_c('footer')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_local_ProtocolNew__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_local_Protocols__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_local_ProtocolEdit__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_api_Protocols__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_api_ProtocolEdit__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Signature__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_auth_Login__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_users_Users__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_users_UserEdit__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_users_UserNew__ = __webpack_require__(930);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: configRoutes()
}));

function configRoutes() {
  return [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_5__views_api_Protocols__["a" /* default */],
    name: 'ApiProtocols'
  }, {
    path: '/local/protocols/new',
    name: 'ProtocolNew',
    component: __WEBPACK_IMPORTED_MODULE_2__views_local_ProtocolNew__["a" /* default */]
  }, {
    path: '/local/protocols',
    component: __WEBPACK_IMPORTED_MODULE_3__views_local_Protocols__["a" /* default */],
    name: 'LocalProtocols'
  }, {
    path: '/local/protocols/:id',
    name: 'LocalProtocolEdit',
    component: __WEBPACK_IMPORTED_MODULE_4__views_local_ProtocolEdit__["a" /* default */]
  }, {
    path: '/protocols/:id',
    name: 'ApiProtocolEdit',
    component: __WEBPACK_IMPORTED_MODULE_6__views_api_ProtocolEdit__["a" /* default */]
  }, {
    path: '/local/protocols/:id/signature/:subject',
    name: 'Signature',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Signature__["a" /* default */]
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_8__views_auth_Login__["a" /* default */],
    name: 'Login'
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_9__views_users_Users__["a" /* default */]
  }, {
    path: '/users/new',
    name: 'UserNew',
    component: __WEBPACK_IMPORTED_MODULE_11__views_users_UserNew__["a" /* default */]
  }, {
    path: '/users/:id',
    name: 'UserEdit',
    component: __WEBPACK_IMPORTED_MODULE_10__views_users_UserEdit__["a" /* default */]
  }];
}

/***/ }),

/***/ 910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolNew_vue__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6860b529_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolNew_vue__ = __webpack_require__(912);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6860b529_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.download_data)?_c('div',{staticClass:"container-fluid"},[_c('H2',[_vm._v(_vm._s(_vm.$trans.protocol.header))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-row',[_c('div',{staticClass:"form-group col-sm-3"},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},model:{value:(_vm.protocol.cause.preliminary),callback:function ($$v) {_vm.$set(_vm.protocol.cause, "preliminary", $$v)},expression:"protocol.cause.preliminary"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.cause.preliminary)+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},model:{value:(_vm.protocol.cause.final),callback:function ($$v) {_vm.$set(_vm.protocol.cause, "final", $$v)},expression:"protocol.cause.final"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.cause.final)+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},model:{value:(_vm.protocol.cause.state),callback:function ($$v) {_vm.$set(_vm.protocol.cause, "state", $$v)},expression:"protocol.cause.state"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.cause.state)+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},model:{value:(_vm.protocol.cause.transmission),callback:function ($$v) {_vm.$set(_vm.protocol.cause, "transmission", $$v)},expression:"protocol.cause.transmission"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.cause.transmission)+"\n        ")])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-row',[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{attrs:{"for":"object"}},[_vm._v(_vm._s(_vm.$trans.protocol.object))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.object),expression:"protocol.object"}],staticClass:"form-control",attrs:{"name":"object","id":"object"},domProps:{"value":(_vm.protocol.object)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "object", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{attrs:{"for":"tenant"}},[_vm._v(_vm._s(_vm.$trans.protocol.tenant))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.tenant),expression:"protocol.tenant"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"tenant","id":"tenant"},domProps:{"value":(_vm.protocol.tenant)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "tenant", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('label',{attrs:{"for":"street"}},[_vm._v(_vm._s(_vm.$trans.protocol.street))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.street),expression:"protocol.street"}],staticClass:"form-control",attrs:{"name":"street","id":"street"},domProps:{"value":(_vm.protocol.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "street", $event.target.value)}}})])]),_vm._v(" "),_c('b-form-row',{staticClass:"mt-2"},[_c('div',{staticClass:"form-group col"},[_c('label',{staticStyle:{"float":"left","margin-right":"5px"},attrs:{"for":"floor"}},[_vm._v(_vm._s(_vm.$trans.protocol.floor))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.floor),expression:"protocol.floor"}],staticClass:"form-control",staticStyle:{"width":"100px","margin":"-7px 0px"},attrs:{"autocomplete":"off","name":"floor","id":"floor"},domProps:{"value":(_vm.protocol.floor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "floor", $event.target.value)}}})])]),_vm._v(" "),_c('b-form-row',_vm._l((_vm.protocol.location),function(item,item_index){return _c('div',{staticClass:"form-group col "},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},model:{value:(_vm.protocol.location[item_index]),callback:function ($$v) {_vm.$set(_vm.protocol.location, item_index, $$v)},expression:"protocol.location[item_index]"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.location[item_index])+"\n        ")])],1)}),0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-row',[_c('div',{staticClass:"col-md-4"},[_c('h3',[_vm._v(_vm._s(_vm.$trans.protocol.structure_header))]),_vm._v(" "),_vm._l((_vm.protocol.structure),function(structure,index){return _c('div',{staticClass:"form-group"},[(index !== 'basement_number_number' && index !== 'attic_number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.structure[index]),expression:"protocol.structure[index]"}],staticClass:"form-control inline",staticStyle:{"width":"3.5rem","margin-left":"0"},attrs:{"autocomplete":"off","name":index,"id":index},domProps:{"value":(_vm.protocol.structure[index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.structure, index, $event.target.value)}}}):_vm._e(),_vm._v(" "),(index !== 'basement_number_number' && index !== 'attic_number')?_c('label',{attrs:{"for":index}},[_vm._v(_vm._s(_vm.$trans.protocol.structure[index]))]):_vm._e(),_vm._v(" "),(index === 'basement_number' || index === 'attic')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.structure[index + '_number']),expression:"protocol.structure[index + '_number']"}],staticClass:"form-control inline",staticStyle:{"width":"3.5rem","margin-left":"0"},attrs:{"autocomplete":"off","name":index,"id":index + '_number'},domProps:{"value":(_vm.protocol.structure[index + '_number'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.structure, index + '_number', $event.target.value)}}}):_vm._e()])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h3',[_vm._v(_vm._s(_vm.$trans.protocol.furniture_header))]),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('tbody',_vm._l((_vm.protocol.furniture),function(items,index){return _c('tr',[_c('td',_vm._l((items),function(item,item_index){return _c('div',[(item_index !== 'other_value')?_c('b-form-checkbox',{attrs:{"value":true,"unchecked-value":false},model:{value:(_vm.protocol.furniture[index][item_index]),callback:function ($$v) {_vm.$set(_vm.protocol.furniture[index], item_index, $$v)},expression:"protocol.furniture[index][item_index]"}},[_vm._v("\n                  "+_vm._s(_vm.$trans.protocol.furniture[index][item_index])+"\n                ")]):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.furniture[index][item_index]),expression:"protocol.furniture[index][item_index]"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":index + item_index,"id":index,"readonly":!_vm.protocol.furniture.heating.other},domProps:{"value":(_vm.protocol.furniture[index][item_index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.furniture[index], item_index, $event.target.value)}}})],1)}),0)])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h3',[_vm._v(_vm._s(_vm.$trans.protocol.meters_data_header))]),_vm._v(" "),_vm._l((_vm.protocol.meters_data),function(item,index){return _c('div',{staticClass:"form-row"},[_c('b-col',{attrs:{"cols":"6"}},[_c('label',{attrs:{"for":index}},[_vm._v(_vm._s(_vm.$trans.protocol.meters_data[index]))])]),_vm._v(" "),_c('b-col',{staticStyle:{"margin-bottom":"1rem"},attrs:{"cols":"6"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.meters_data[index]),expression:"protocol.meters_data[index]"}],staticClass:"form-control inline",attrs:{"autocomplete":"off","name":index,"id":index},domProps:{"value":(_vm.protocol.meters_data[index])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.meters_data, index, $event.target.value)}}})])],1)})],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.protocol.rooms),function(room,room_index){return _c('b-form',{attrs:{"id":'room_name_' + room_index}},[_c('b-form-row',[_c('div',{staticClass:"col"},[_c('h4',{staticStyle:{"margin-top":"0.5rem"}},[_vm._v(_vm._s(room.name))])]),_vm._v(" "),_c('div',{staticClass:"col"},[(room_index > 2)?_c('b-button',{staticClass:"btn btn-danger float-right",on:{"click":function($event){_vm.delete_room_index = room_index; _vm.$bvModal.show('delete_room_modal')}}},[_vm._v("\n            "+_vm._s(_vm.$trans.main.button_delete_room)+"\n          ")]):_vm._e()],1)]),_vm._v(" "),_vm._l((room),function(item,item_index){return (!['boiler_other', 'images', 'images_amount', 'id', 'bath_structure', 'washbasin_structure', 'wall_tile_structure'].includes(item_index)
         && !(item_index === 'name' && +room_index < 3))?_c('div',{staticClass:"form-group"},[((typeof item !== 'boolean' && !['notes_text', 'boiler_other', 'bath', 'washbasin', 'wall_tile'].includes(item_index))
        || (item_index === 'bath' && _vm.protocol.rooms[room_index]['bath_structure'] === undefined)
        || (item_index === 'washbasin' && _vm.protocol.rooms[room_index]['washbasin_structure'] === undefined)
        || (item_index === 'wall_tile' && _vm.protocol.rooms[room_index]['wall_tile_structure'] === undefined))?_c('label',{attrs:{"for":room_index + item_index}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.rooms[item_index])+"\n        ")]):(item_index === 'bath')?_c('b-row',{staticClass:"mb-2",attrs:{"for":room_index + item_index}},_vm._l((_vm.protocol.rooms[room_index]['bath_structure']),function(checkbox_item,checkbox_index){return _c('b-col',{staticClass:"col-auto"},[_c('nobr',[_c('b-form-checkbox',{staticClass:"custom-control custom-checkbox",attrs:{"value":true,"unchecked-value":false,"id":room_index + item_index + checkbox_index},model:{value:(_vm.protocol.rooms[room_index]['bath_structure'][checkbox_index]),callback:function ($$v) {_vm.$set(_vm.protocol.rooms[room_index]['bath_structure'], checkbox_index, $$v)},expression:"protocol.rooms[room_index]['bath_structure'][checkbox_index]"}},[_vm._v("\n                "+_vm._s(_vm.$trans.protocol.rooms['bath_structure'][checkbox_index])+"\n              ")])],1)],1)}),1):(item_index === 'washbasin')?_c('b-row',{staticClass:"mb-2",attrs:{"for":room_index + item_index}},_vm._l((_vm.protocol.rooms[room_index]['washbasin_structure']),function(checkbox_item,checkbox_index){return _c('b-col',{staticClass:"col-auto"},[_c('nobr',[_c('b-form-checkbox',{staticClass:"custom-control custom-checkbox",attrs:{"value":true,"unchecked-value":false,"id":room_index + item_index + checkbox_index},model:{value:(_vm.protocol.rooms[room_index]['washbasin_structure'][checkbox_index]),callback:function ($$v) {_vm.$set(_vm.protocol.rooms[room_index]['washbasin_structure'], checkbox_index, $$v)},expression:"protocol.rooms[room_index]['washbasin_structure'][checkbox_index]"}},[_vm._v("\n                "+_vm._s(_vm.$trans.protocol.rooms['washbasin_structure'][checkbox_index])+"\n              ")])],1)],1)}),1):(item_index === 'wall_tile')?_c('b-row',{staticClass:"mb-2",attrs:{"for":room_index + item_index}},[_c('b-col',{staticClass:"col-auto"},[_vm._v("\n            "+_vm._s(_vm.$trans.protocol.rooms['wall_tile_structure']['wandfliesen'])+"\n          ")]),_vm._v(" "),_c('b-col',{staticClass:"col-auto"},[_c('b-form-checkbox',{staticClass:"custom-control custom-checkbox",attrs:{"value":true,"unchecked-value":false,"id":room_index + item_index + 'raumhoch'},model:{value:(_vm.protocol.rooms[room_index]['wall_tile_structure']['raumhoch']),callback:function ($$v) {_vm.$set(_vm.protocol.rooms[room_index]['wall_tile_structure'], 'raumhoch', $$v)},expression:"protocol.rooms[room_index]['wall_tile_structure']['raumhoch']"}},[_vm._v("\n              "+_vm._s(_vm.$trans.protocol.rooms['wall_tile_structure']['raumhoch'])+"\n            ")])],1),_vm._v(" "),_c('b-col',{staticClass:"col-auto"},[_c('b-form-checkbox',{staticClass:"custom-control custom-checkbox",attrs:{"value":true,"unchecked-value":false,"id":room_index + item_index + 'halbhoch'},model:{value:(_vm.protocol.rooms[room_index]['wall_tile_structure']['halbhoch']),callback:function ($$v) {_vm.$set(_vm.protocol.rooms[room_index]['wall_tile_structure'], 'halbhoch', $$v)},expression:"protocol.rooms[room_index]['wall_tile_structure']['halbhoch']"}},[_vm._v("\n              "+_vm._s(_vm.$trans.protocol.rooms['wall_tile_structure']['halbhoch'])+"\n            ")])],1),_vm._v(" "),_c('b-col',{staticClass:"col-auto"},[_c('b-form-checkbox',{staticClass:"custom-control custom-checkbox",attrs:{"value":true,"unchecked-value":false,"id":room_index + item_index + 'turhoch'},model:{value:(_vm.protocol.rooms[room_index]['wall_tile_structure']['turhoch']),callback:function ($$v) {_vm.$set(_vm.protocol.rooms[room_index]['wall_tile_structure'], 'turhoch', $$v)},expression:"protocol.rooms[room_index]['wall_tile_structure']['turhoch']"}},[_vm._v("\n              "+_vm._s(_vm.$trans.protocol.rooms['wall_tile_structure']['turhoch'])+"\n            ")])],1)],1):_vm._e(),_vm._v(" "),(typeof item === 'boolean' && item_index !== 'access')?_c('b-form-checkbox',{class:item_index.indexOf('boiler') > -1 ? ' float-left ': '',style:(item_index.indexOf('boiler') > -1 ? ' margin-right: 5px; ' : ''),attrs:{"value":true,"id":room_index + item_index,"unchecked-value":false},model:{value:(_vm.protocol.rooms[room_index][item_index]),callback:function ($$v) {_vm.$set(_vm.protocol.rooms[room_index], item_index, $$v)},expression:"protocol.rooms[room_index][item_index]"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.rooms[item_index])+"\n        ")]):(typeof item === 'boolean' && item_index === 'access')?_c('b-form-group',{attrs:{"id":room_index + item_index,"label":_vm.trans.protocol.rooms[item_index]}},[_c('b-form-radio-group',{attrs:{"id":room_index + item_index + '-radio-slots',"options":[{text: _vm.trans.main.boolean.true, value: true}, {text: _vm.trans.main.boolean.false, value: false}]},model:{value:(_vm.protocol.rooms[room_index][item_index]),callback:function ($$v) {_vm.$set(_vm.protocol.rooms[room_index], item_index, $$v)},expression:"protocol.rooms[room_index][item_index]"}})],1):(item_index === 'notes_text')?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.rooms[room_index][item_index] ),expression:"protocol.rooms[room_index][item_index] "}],staticClass:"form-control",attrs:{"rows":"5","id":room_index + item_index,"readonly":!_vm.protocol.rooms[room_index].notes,"autocomplete":"off"},domProps:{"value":(_vm.protocol.rooms[room_index][item_index] )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.rooms[room_index], item_index, $event.target.value)}}}):(item_index !== 'exist_boiler_other')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.rooms[room_index][item_index] ),expression:"protocol.rooms[room_index][item_index] "}],staticClass:"form-control",attrs:{"autocomplete":['radiator_value' ].includes(item_index) ? 'off' : 'on',"name":item_index,"id":room_index + item_index},domProps:{"value":(_vm.protocol.rooms[room_index][item_index] )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.rooms[room_index], item_index, $event.target.value)}}}):_vm._e(),_vm._v(" "),(item_index === 'exist_boiler_other' )?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.rooms[room_index].boiler_other),expression:"protocol.rooms[room_index].boiler_other"}],staticClass:"form-control inline ml-1 mt-2 ",staticStyle:{"margin-left":"1rem","width":"300px"},attrs:{"autocomplete":['radiator_value' ].includes(item_index) ? 'off' : 'on',"name":item_index,"readonly":!_vm.protocol.rooms[room_index].exist_boiler_other,"id":"boiler_other"},domProps:{"value":(_vm.protocol.rooms[room_index].boiler_other)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol.rooms[room_index], "boiler_other", $event.target.value)}}}):_vm._e()],1):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"form-row",staticStyle:{"margin-bottom":"3em"}},_vm._l((room.images),function(image,image_index){return _c('div',{staticClass:"rounded float-left thumbnail img-responsive p-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('img',{staticClass:"rounded float-left img-thumbnail thumbnail",attrs:{"src":image.small.blob},on:{"click":function($event){return _vm.openBigImage(image)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-button',{staticClass:"btn-danger btn-block border-bottom-0 mb-1",on:{"click":function($event){return _vm.deleteImage(room_index, image_index)}}},[_vm._v(_vm._s(_vm.$trans.main.button_delete)+"\n              ")])],1)])])}),0),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"btn btn-primary btn-block"},[_c('input',{attrs:{"autocomplete":"off","name":"add_image","type":"file","accept":"image/*","capture":"camera","hidden":""},on:{"change":function($event){return _vm.filesChange($event.target.files[0], room_index)}}}),_vm._v("\n          "+_vm._s(_vm.$trans.main.button_add_image)+"\n        ")])]),_vm._v(" "),_c('hr')],2)}),_vm._v(" "),_c('b-modal',{attrs:{"size":"xl","id":"modal-big-image","hide-footer":"","hide-header":""}},[_c('div',{staticClass:"d-block text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.modal_image}})]),_vm._v(" "),_c('b-button',{staticClass:"mt-3",attrs:{"block":""},on:{"click":function($event){return _vm.$bvModal.hide('modal-big-image')}}},[_vm._v(_vm._s(_vm.trans.main.button_success)+"\n      ")])],1),_vm._v(" "),_c('b-form',[_c('div',{staticClass:"form-group"},[_c('b-button',{staticClass:"btn btn-success form-control",on:{"click":function($event){return _vm.addRoom()}}},[_vm._v(_vm._s(_vm.$trans.protocol.rooms.button_add)+"\n        ")])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('b-form',[_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"basement_description","unchecked-value":false},model:{value:(_vm.protocol.basement_description),callback:function ($$v) {_vm.$set(_vm.protocol, "basement_description", $$v)},expression:"protocol.basement_description"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.basement_description)+"\n        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.basement_description_text ),expression:"protocol.basement_description_text "}],staticClass:"form-control",attrs:{"rows":"5","id":"basement_description_text","readonly":!_vm.protocol.basement_description},domProps:{"value":(_vm.protocol.basement_description_text )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "basement_description_text", $event.target.value)}}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"balcony_description","unchecked-value":false},model:{value:(_vm.protocol.balcony_description),callback:function ($$v) {_vm.$set(_vm.protocol, "balcony_description", $$v)},expression:"protocol.balcony_description"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.balcony_description)+"\n        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.balcony_description_text ),expression:"protocol.balcony_description_text "}],staticClass:"form-control",attrs:{"rows":"5","id":"balcony_description_text","readonly":!_vm.protocol.balcony_description},domProps:{"value":(_vm.protocol.balcony_description_text )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "balcony_description_text", $event.target.value)}}})],1),_vm._v(" "),_c('hr')],1),_vm._v(" "),_c('b-form',[_c('b-form-group',[_c('label',{attrs:{"for":"remarks"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.remarks)+"\n        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.remarks),expression:"protocol.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks"},domProps:{"value":(_vm.protocol.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "remarks", $event.target.value)}}})]),_vm._v(" "),_c('hr')],1),_vm._v(" "),_c('b-form',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$trans.protocol.state_header))])]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"maintenance_boiler"}},[_c('b-form-row',[_c('label',{staticStyle:{"margin-right":"0.5rem"}},[_vm._v(_vm._s(_vm.trans.protocol.maintenance_boiler_header))]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"custom-control-inline",attrs:{"id":"maintenance_boiler_checkbox1","value":true,"unchecked-value":false,"name":"maintenance_boiler_checkbox1"},model:{value:(_vm.protocol.maintenance_boiler_done),callback:function ($$v) {_vm.$set(_vm.protocol, "maintenance_boiler_done", $$v)},expression:"protocol.maintenance_boiler_done"}},[_c('label',[_vm._v(_vm._s(_vm.trans.protocol.maintenance_boiler_done))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.maintenance_boiler_date),expression:"protocol.maintenance_boiler_date"}],staticClass:"form-control inline",staticStyle:{"margin-left":"0","margin-right":"0"},attrs:{"autocomplete":"off","name":"maintenance_boiler_done","readonly":!_vm.protocol.maintenance_boiler_done,"type":"date","id":"maintenance_boiler_date"},domProps:{"value":(_vm.protocol.maintenance_boiler_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "maintenance_boiler_date", $event.target.value)}}}),_vm._v(" "),_c('label',{staticStyle:{"margin-left":"0.5rem","margin-right":"1rem"}},[_vm._v("durchgeführt")]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"custom-control-inline",attrs:{"id":"maintenance_boiler_not_done_checkbox","value":true,"unchecked-value":false,"name":"maintenance_boiler_checkbox2"},model:{value:(_vm.protocol.maintenance_boiler_not_done),callback:function ($$v) {_vm.$set(_vm.protocol, "maintenance_boiler_not_done", $$v)},expression:"protocol.maintenance_boiler_not_done"}},[_c('label',[_vm._v(" "+_vm._s(_vm.trans.protocol.maintenance_boiler_not_done))])]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":true,"id":"maintenance_boiler_executor_owner","unchecked-value":false},model:{value:(_vm.protocol.maintenance_boiler_executor_owner),callback:function ($$v) {_vm.$set(_vm.protocol, "maintenance_boiler_executor_owner", $$v)},expression:"protocol.maintenance_boiler_executor_owner"}},[_vm._v("\n            "+_vm._s(_vm.$trans.protocol.maintenance_boiler_executor_owner)+"\n          ")])],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"warmly_pays"}},[_c('b-form-row',[_c('label',{staticStyle:{"margin-right":"0.5rem"}},[_vm._v(" "+_vm._s(_vm.trans.protocol.warmly_pays))]),_vm._v(" "),_c('b-form-radio-group',{staticClass:"custom-control-inline",attrs:{"id":"warmly_pays-radio","options":[{text: _vm.trans.protocol.warmly_pays_tenant, value: true}, {text: _vm.trans.protocol.warmly_pays_owner, value: false}],"name":"warmly_pays"},model:{value:(_vm.protocol.warmly_pays),callback:function ($$v) {_vm.$set(_vm.protocol, "warmly_pays", $$v)},expression:"protocol.warmly_pays"}})],1)],1),_vm._v(" "),_c('hr')],1),_vm._v(" "),_c('b-form',[_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"tenant_eliminate_defects","unchecked-value":false},model:{value:(_vm.protocol.tenant_eliminate_defects),callback:function ($$v) {_vm.$set(_vm.protocol, "tenant_eliminate_defects", $$v)},expression:"protocol.tenant_eliminate_defects"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.tenant_eliminate_defects)+"\n        ")])],1),_vm._v(" "),_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.tenant_eliminate_defects_method),expression:"protocol.tenant_eliminate_defects_method"}],staticClass:"form-control inline ml-0",attrs:{"autocomplete":"off","name":"tenant_eliminate_defects","readonly":!_vm.protocol.tenant_eliminate_defects,"type":"date","id":"tenant_eliminate_defects_method"},domProps:{"value":(_vm.protocol.tenant_eliminate_defects_method)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "tenant_eliminate_defects_method", $event.target.value)}}})]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"tenant_warned_of_deadline","unchecked-value":false},model:{value:(_vm.protocol.tenant_warned_of_deadline),callback:function ($$v) {_vm.$set(_vm.protocol, "tenant_warned_of_deadline", $$v)},expression:"protocol.tenant_warned_of_deadline"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.tenant_warned_of_deadline)+"\n        ")])],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"repairs_delegates_the_execution","unchecked-value":false},model:{value:(_vm.protocol.repairs_delegates_the_execution),callback:function ($$v) {_vm.$set(_vm.protocol, "repairs_delegates_the_execution", $$v)},expression:"protocol.repairs_delegates_the_execution"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.repairs_delegates_the_execution)+"\n        ")]),_vm._v(" "),_c('b-form-radio',{staticClass:"custom-control-inline",staticStyle:{"line-height":"1.9"},attrs:{"id":"repairs_budget_tenant","value":_vm.trans.protocol.repairs_budget_tenant,"checked":_vm.protocol.repairs_budget === _vm.trans.protocol.repairs_budget_tenant,"disabled":!_vm.protocol.repairs_delegates_the_execution},model:{value:(_vm.protocol.repairs_budget),callback:function ($$v) {_vm.$set(_vm.protocol, "repairs_budget", $$v)},expression:"protocol.repairs_budget"}},[_c('strong',{staticStyle:{"line-height":"1.9"}},[_vm._v(_vm._s(_vm.trans.protocol.repairs_budget_tenant))])]),_vm._v(" "),_c('b-form-radio',{staticClass:"custom-control-inline",staticStyle:{"line-height":"1.9","margin":"0"},attrs:{"id":"repairs_budget_rent","value":_vm.trans.protocol.repairs_budget_rent,"checked":_vm.protocol.repairs_budget === _vm.trans.protocol.repairs_budget_rent,"disabled":!_vm.protocol.repairs_delegates_the_execution},model:{value:(_vm.protocol.repairs_budget),callback:function ($$v) {_vm.$set(_vm.protocol, "repairs_budget", $$v)},expression:"protocol.repairs_budget"}}),_vm._v(" "),_c('strong',{staticClass:"custom-control-inline",staticStyle:{"word-wrap":"break-word","line-height":"1.9","margin-left":"-0.5rem","margin-right":"0"}},[_vm._v(_vm._s(_vm.trans.protocol.repairs_budget_rent)+"\n        ")]),_vm._v("\n        "+_vm._s(_vm.trans.protocol.repairs_budget_rent2)+"\n      ")],1),_vm._v(" "),_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.repairs_deadline),expression:"protocol.repairs_deadline"}],staticClass:"ml-0 form-control inline ",attrs:{"autocomplete":"off","name":"repairs_delegates_the_execution","type":"date","readonly":!_vm.protocol.repairs_delegates_the_execution},domProps:{"value":(_vm.protocol.repairs_deadline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "repairs_deadline", $event.target.value)}}}),_vm._v("\n        "+_vm._s(_vm.$trans.protocol.repairs_delegates_the_execution2)+"\n      ")]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"tenant_refuses_to_eliminate","unchecked-value":false},model:{value:(_vm.protocol.tenant_refuses_to_eliminate),callback:function ($$v) {_vm.$set(_vm.protocol, "tenant_refuses_to_eliminate", $$v)},expression:"protocol.tenant_refuses_to_eliminate"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.tenant_refuses_to_eliminate)+"\n        ")]),_vm._v(" "),(_vm.protocol.tenant_refuses_to_eliminate)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.tenant_refuses_to_eliminate_reason),expression:"protocol.tenant_refuses_to_eliminate_reason"}],staticClass:"form-control",attrs:{"rows":"2","id":"tenant_refuses_to_eliminate_reason"},domProps:{"value":(_vm.protocol.tenant_refuses_to_eliminate_reason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "tenant_refuses_to_eliminate_reason", $event.target.value)}}}):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"inline":"","value":true,"id":"tenant_eliminate_defects_pays","unchecked-value":false},model:{value:(_vm.protocol.tenant_eliminate_defects_pays),callback:function ($$v) {_vm.$set(_vm.protocol, "tenant_eliminate_defects_pays", $$v)},expression:"protocol.tenant_eliminate_defects_pays"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.tenant_eliminate_defects_pays_sum)+"\n        ")])],1),_vm._v(" "),_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.tenant_eliminate_defects_pays_sum ),expression:"protocol.tenant_eliminate_defects_pays_sum "}],staticClass:"form-control inline ml-0",attrs:{"autocomplete":"off","name":"tenant_eliminate_defects_pays_sum","readonly":!_vm.protocol.tenant_eliminate_defects_pays,"id":"tenant_eliminate_defects_pays_sum"},domProps:{"value":(_vm.protocol.tenant_eliminate_defects_pays_sum )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "tenant_eliminate_defects_pays_sum", $event.target.value)}}}),_vm._v("\n        "+_vm._s(_vm.$trans.main.currency)+"\n      ")]),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"strange_text","unchecked-value":false},model:{value:(_vm.protocol.strange_text),callback:function ($$v) {_vm.$set(_vm.protocol, "strange_text", $$v)},expression:"protocol.strange_text"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.strange_text)+"\n        ")])],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"barter","unchecked-value":false},model:{value:(_vm.protocol.barter),callback:function ($$v) {_vm.$set(_vm.protocol, "barter", $$v)},expression:"protocol.barter"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.barter)+"\n        ")]),_vm._v(" "),(_vm.protocol.barter)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.barter_text ),expression:"protocol.barter_text "}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"barter_text","id":"barter_text"},domProps:{"value":(_vm.protocol.barter_text )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "barter_text", $event.target.value)}}}):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":true,"id":"accept","unchecked-value":false},model:{value:(_vm.protocol.accept),callback:function ($$v) {_vm.$set(_vm.protocol, "accept", $$v)},expression:"protocol.accept"}},[_vm._v("\n          "+_vm._s(_vm.$trans.protocol.accept1)+"\n          "),_c('b-form-radio-group',{attrs:{"id":"condition-radio-slots","options":[
          {text: _vm.trans.protocol.condition_perfect, value: _vm.trans.protocol.condition_perfect},
          {text: _vm.trans.protocol.condition_satisfactory, value: _vm.trans.protocol.condition_satisfactory},
          {text: _vm.trans.protocol.condition_agreement, value: _vm.trans.protocol.condition_agreement}
        ]},model:{value:(_vm.protocol.condition),callback:function ($$v) {_vm.$set(_vm.protocol, "condition", $$v)},expression:"protocol.condition"}}),_vm._v("\n          "+_vm._s(_vm.$trans.protocol.accept2)),_c('br'),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$trans.protocol.accept3))])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"new_address"}},[_vm._v(_vm._s(_vm.$trans.protocol.new_address))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.new_address),expression:"protocol.new_address"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"new_address","id":"new_address"},domProps:{"value":(_vm.protocol.new_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "new_address", $event.target.value)}}})]),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"kontoverbindung"}},[_vm._v(_vm._s(_vm.$trans.protocol.kontoverbindung))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.kontoverbindung),expression:"protocol.kontoverbindung"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"kontoverbindung","id":"kontoverbindung"},domProps:{"value":(_vm.protocol.kontoverbindung)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "kontoverbindung", $event.target.value)}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$trans.protocol.keys_header))]),_vm._v(" "),_c('b-form-row',_vm._l((_vm.protocol.keys),function(value,key){return _c('div',{staticClass:"col-3"},[_c('label',{attrs:{"for":'key_' + key}},[_vm._v("\n            "+_vm._s(_vm.$trans.protocol.keys[key])+"\n          ")]),_vm._v(" "),_c('b-input',{staticClass:"form-control",attrs:{"autocomplete":"off","id":'key_' + key},model:{value:(_vm.protocol.keys[key]),callback:function ($$v) {_vm.$set(_vm.protocol.keys, key, $$v)},expression:"protocol.keys[key]"}})],1)}),0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.notices),expression:"protocol.notices"}],staticClass:"form-control",attrs:{"rows":"5","id":"notices"},domProps:{"value":(_vm.protocol.notices)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "notices", $event.target.value)}}})]),_vm._v("\n      "+_vm._s(_vm.$trans.protocol.footer_text)+"\n      "),_c('hr')],1),_vm._v(" "),_c('h4',[_vm._v("Unterschriften")]),_vm._v(" "),_c('b-form-row',[_c('div',{staticClass:"col-3",attrs:{"id":_vm.protocol.api_id + '_' + _vm.protocol.id +  'signature_owner'}},[_c('div',{staticClass:"form-group"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.protocol.signature_owner}}),_vm._v(" "),_c('b-button',{staticClass:"form-control btn-info",on:{"click":function($event){return _vm.signatureEdit('signature_owner')}}},[_vm._v("\n            "+_vm._s(_vm.$trans.protocol.signature_owner)+"\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-3",attrs:{"id":_vm.protocol.api_id + '_' + _vm.protocol.id +  'signature_inspector'}},[_c('div',{staticClass:"form-group"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.protocol.signature_inspector}}),_vm._v(" "),_c('b-button',{staticClass:"form-control btn-info",on:{"click":function($event){return _vm.signatureEdit('signature_inspector')}}},[_vm._v("\n            "+_vm._s(_vm.$trans.protocol.signature_inspector)+"\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-3",attrs:{"id":_vm.protocol.api_id + '_' + _vm.protocol.id +  'signature_tenant'}},[_c('div',{staticClass:"form-group"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.protocol.signature_tenant}}),_vm._v(" "),_c('b-button',{staticClass:"form-control btn-info",on:{"click":function($event){return _vm.signatureEdit('signature_tenant')}}},[_vm._v("\n            "+_vm._s(_vm.$trans.protocol.signature_tenant)+"\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-3",attrs:{"id":_vm.protocol.api_id + '_' + _vm.protocol.id +  'signature_old_tenant'}},[_c('div',{staticClass:"form-group"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.protocol.signature_old_tenant}}),_vm._v(" "),_c('b-button',{staticClass:"form-control btn-info",on:{"click":function($event){return _vm.signatureEdit('signature_old_tenant')}}},[_vm._v("\n            "+_vm._s(_vm.$trans.protocol.signature_old_tenant)+"\n          ")])],1)]),_vm._v("\n      Unterschriften wurden digital erfasst\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-row',[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Datum")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.date),expression:"protocol.date"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"date","type":"date"},domProps:{"value":(_vm.protocol.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "date", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Email-Adressen")]),_vm._v(" "),_c('b-form-row',[_c('div',{staticClass:"col"},[_c('b-form-group',[_c('label',{attrs:{"for":"email_owner"}},[_vm._v(_vm._s(_vm.$trans.protocol.email_owner))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.email_owner),expression:"protocol.email_owner"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"email_owner","id":"email_owner"},domProps:{"value":(_vm.protocol.email_owner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "email_owner", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-form-group',[_c('label',{attrs:{"for":"email_inspector"}},[_vm._v(_vm._s(_vm.$trans.protocol.email_inspector))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.email_inspector),expression:"protocol.email_inspector"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"email_inspector","id":"email_inspector"},domProps:{"value":(_vm.protocol.email_inspector)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "email_inspector", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-form-group',[_c('label',{attrs:{"for":"email_tenant"}},[_vm._v(_vm._s(_vm.$trans.protocol.email_tenant))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.email_tenant),expression:"protocol.email_tenant"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"email_tenant","id":"email_tenant"},domProps:{"value":(_vm.protocol.email_tenant)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "email_tenant", $event.target.value)}}})])],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-form-group',[_c('label',{attrs:{"for":"email_old_tenant"}},[_vm._v(_vm._s(_vm.$trans.protocol.email_old_tenant))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.protocol.email_old_tenant),expression:"protocol.email_old_tenant"}],staticClass:"form-control",attrs:{"autocomplete":"off","name":"email_old_tenant","id":"email_old_tenant"},domProps:{"value":(_vm.protocol.email_old_tenant)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.protocol, "email_old_tenant", $event.target.value)}}})])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('b-form',{staticClass:"sticky-bottom"},[(_vm.await_spinner)?_c('div',{staticClass:"form-group"},[_c('b-spinner',{attrs:{"variant":"success"}})],1):_c('div',{staticClass:"form-group"},[_c('b-button',{staticClass:"btn btn-success px-1",on:{"click":function($event){return _vm.save(false, false)}}},[_vm._v(_vm._s(_vm.$trans.protocol.button_save)+"\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-success px-1",on:{"click":function($event){return _vm.save(false, true)}}},[_vm._v(_vm._s(_vm.$trans.protocol.button_save_and_close)+"\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-success px-1",on:{"click":function($event){return _vm.save(true, true)}}},[_vm._v(_vm._s(_vm.$trans.main.button_save_and_send_mails)+"\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-primary px-1",on:{"click":function($event){return _vm.$bvModal.show('copy_modal')}}},[_vm._v(_vm._s(_vm.$trans.main.button_copy)+"\n        ")]),_vm._v(" "),(!_vm.local)?_c('b-button',{staticClass:"btn btn-secondary px-1",on:{"click":function($event){return _vm.getPdf()}}},[_vm._v(_vm._s(_vm.$trans.main.button_get_pdf)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.local)?_c('b-button',{staticClass:"btn btn-danger px-1",on:{"click":function($event){return _vm.back()}}},[_vm._v("Abbrechen und Daten löschen")]):_vm._e()],1)]),_vm._v(" "),_c('b-modal',{attrs:{"hide-footer":"","hide-header":"","id":"copy_modal","color":"warning"}},[_vm._v("\n      "+_vm._s(_vm.$trans.main.warning_copy)+"\n      "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-secondary","block":""},on:{"click":function($event){return _vm.$bvModal.hide('copy_modal')}}},[_vm._v("\n        "+_vm._s(_vm.$trans.main.button_cancel)+"\n      ")]),_vm._v(" "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-success","block":""},on:{"click":function($event){_vm.$bvModal.hide('copy_modal'); _vm.copy()}}},[_vm._v("\n        "+_vm._s(_vm.$trans.main.button_copy)+"\n      ")])],1),_vm._v(" "),_c('b-modal',{attrs:{"hide-footer":"","hide-header":"","id":"delete_room_modal","color":"warning"}},[_vm._v("\n      "+_vm._s(_vm.$trans.main.delete_room_warning)+"\n      "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-secondary","block":""},on:{"click":function($event){return _vm.$bvModal.hide('delete_room_modal')}}},[_vm._v("\n        "+_vm._s(_vm.$trans.main.button_cancel)+"\n      ")]),_vm._v(" "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-danger","block":""},on:{"click":function($event){_vm.$bvModal.hide('delete_room_modal'); _vm.deleteRoom()}}},[_vm._v("\n        "+_vm._s(_vm.$trans.main.button_delete)+"\n      ")])],1)],2):_c('div',{staticClass:"container"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"col d-flex justify-content-center"},[_c('b-spinner',{attrs:{"variant":"success"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProtocolEditComponent',{attrs:{"local":true,"new":true,"id":this.$route.params.id}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protocols_vue__ = __webpack_require__(603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e39c51ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protocols_vue__ = __webpack_require__(914);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protocols_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e39c51ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protocols_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('b-modal',{attrs:{"hide-footer":"","hide-header":"","id":"delete_modal","color":"warning","show":_vm.warning_modal},on:{"update:show":function($event){_vm.warning_modal=$event}}},[_vm._v("\n    "+_vm._s(_vm.$trans.main.delete_warning)+"\n      "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-secondary","block":""},on:{"click":function($event){return _vm.$bvModal.hide('delete_modal')}}},[_vm._v("\n        "+_vm._s(_vm.$trans.main.button_cancel)+"\n      ")]),_vm._v(" "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-danger","block":""},on:{"click":function($event){_vm.deleteProtocol(_vm.deleted_protocol); _vm.$bvModal.hide('delete_modal')}}},[_vm._v("\n        "+_vm._s(_vm.$trans.main.button_delete)+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('table',{staticClass:"table "},[_c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.date))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.object))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.street))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.tenant))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.status))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.synchronize()}}},[_vm._v(_vm._s(_vm.$trans.main.button_synchronize))])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.protocols),function(protocol){return _c('tr',[_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(_vm.moment(new Date(protocol.date)).format('DD.MM.YYYY')))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(protocol.object))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(protocol.street))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(protocol.tenant))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(protocol.draft ? _vm.$trans.protocol.draft : _vm.$trans.protocol.not_synchronized))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.deleteProtocolWarning(protocol)}}},[_vm._v(_vm._s(_vm.$trans.main.button_delete))])])])}),0)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolEdit_vue__ = __webpack_require__(604);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1c3ad2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolEdit_vue__ = __webpack_require__(916);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1c3ad2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProtocolEditComponent',{attrs:{"local":true,"new":false,"id":this.$route.params.id}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protocols_vue__ = __webpack_require__(605);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f811b7be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protocols_vue__ = __webpack_require__(918);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protocols_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f811b7be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protocols_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('b-modal',{attrs:{"hide-footer":"","hide-header":"","id":"delete_modal","color":"warning","show":_vm.warning_modal},on:{"update:show":function($event){_vm.warning_modal=$event}}},[_vm._v("\n    "+_vm._s(_vm.$trans.main.delete_warning)+"\n    "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-secondary","block":""},on:{"click":function($event){return _vm.$bvModal.hide('delete_modal')}}},[_vm._v("\n      "+_vm._s(_vm.$trans.main.button_cancel)+"\n    ")]),_vm._v(" "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-danger","block":""},on:{"click":function($event){_vm.deleteProtocol(_vm.deleted_protocol); _vm.$bvModal.hide('delete_modal')}}},[_vm._v("\n      "+_vm._s(_vm.$trans.main.button_delete)+"\n    ")])],1),_vm._v(" "),_c('b-modal',{attrs:{"hide-footer":"","hide-header":"","id":"modal_protocol_isset","color":"warning","show":_vm.protocol_isset},on:{"update:show":function($event){_vm.protocol_isset=$event}}},[_vm._v("\n    "+_vm._s(_vm.$trans.main.isset_protocol_local_version)+"\n    "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-secondary","block":""},on:{"click":function($event){_vm.editLocalProtocol(); _vm.$bvModal.hide('modal_protocol_isset')}}},[_vm._v("\n      "+_vm._s(_vm.$trans.main.open_local_version)+"\n    ")]),_vm._v(" "),_c('b-button',{staticClass:"btn mt-3",attrs:{"variant":"outline-danger","block":""},on:{"click":function($event){_vm.deleteLocalProtocol(); _vm.$bvModal.hide('modal_protocol_isset')}}},[_vm._v("\n      "+_vm._s(_vm.$trans.main.delete_local_version)+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('table',{staticClass:"table "},[_c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.date))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.object))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.street))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.protocol.tenant))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}})])]),_vm._v(" "),_c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.date),expression:"filters.date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.filters.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "date", $event.target.value)}}})]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.object ),expression:"filters.object "}],staticClass:"form-control",attrs:{"type":"text","id":"object"},domProps:{"value":(_vm.filters.object )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "object", $event.target.value)}}})]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.street ),expression:"filters.street "}],staticClass:"form-control",attrs:{"type":"text","id":"street"},domProps:{"value":(_vm.filters.street )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "street", $event.target.value)}}})]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.tenant ),expression:"filters.tenant "}],staticClass:"form-control",attrs:{"type":"text","id":"tenant"},domProps:{"value":(_vm.filters.tenant )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "tenant", $event.target.value)}}})]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.getProtocols}},[_vm._v(_vm._s(_vm.$trans.main.button_apply))])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.protocols),function(protocol){return _c('tr',[_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(_vm.moment(new Date(protocol.date)).format('DD.MM.YYYY')))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(protocol.object))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(protocol.street))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editProtocol(protocol)}}},[_vm._v(_vm._s(protocol.tenant))]),_vm._v(" "),_c('td',[(_vm.is_user_admin)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.deleteProtocolWarning(protocol)}}},[_vm._v("\n              "+_vm._s(_vm.$trans.main.button_delete)+"\n            ")]):_vm._e()])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix btn-group col-md-2 offset-md-5"},[(_vm.page != 1)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.page--}}},[_vm._v(" <")]):_vm._e(),_vm._v(" "),_vm._l((_vm.pages.slice(_vm.page-1, _vm.page+5)),function(pageNumber){return _c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.page = pageNumber}}},[_vm._v(" "+_vm._s(pageNumber)+"\n    ")])}),_vm._v(" "),(_vm.page < _vm.pages.length)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.page++}}},[_vm._v(" >\n    ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 919:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolEdit_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c29dd6f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolEdit_vue__ = __webpack_require__(920);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProtocolEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c29dd6f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProtocolEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProtocolEditComponent',{attrs:{"local":false,"new":false,"id":this.$route.params.id}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signature_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf35806_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signature_vue__ = __webpack_require__(923);
function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signature_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf35806_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signature_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 922:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"signature_container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){return _vm.save()}}},[_vm._v(_vm._s(_vm.$trans.main.button_save))]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.setCtx()}}},[_vm._v(_vm._s(_vm.$trans.main.button_clear))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.back()}}},[_vm._v(_vm._s(_vm.$trans.main.button_cancel))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('canvas',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.start),expression:"start",arg:"tap"},{name:"touch",rawName:"v-touch:start",value:(_vm.start),expression:"start",arg:"start"},{name:"touch",rawName:"v-touch:end",value:(_vm.finish),expression:"finish",arg:"end"},{name:"touch",rawName:"v-touch:moving",value:(_vm.draw),expression:"draw",arg:"moving"}],ref:"canvas",staticClass:"border",attrs:{"id":_vm.canvas_id},on:{"tap":function($event){$event.preventDefault();},"start":function($event){$event.preventDefault();},"touchstart":function($event){$event.preventDefault();},"touchmove":function($event){$event.preventDefault();},"touchend":function($event){$event.preventDefault();},"touchcancel":function($event){$event.preventDefault();},"moving":function($event){$event.preventDefault();}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 924:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27387e8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(925);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27387e8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-card',{staticClass:"card col-sm-12 col-lg-6  mx-auto"},[_c('b-card-body',[_c('b-form',[_c('h1',[_vm._v(_vm._s(_vm.$trans.main.auth_header))]),_vm._v(" "),_c('b-alert',{staticClass:"alert alert-danger",attrs:{"closeButton":"","show":_vm.errors}},[_vm._v("\n          "+_vm._s(_vm.error)+"\n        ")]),_vm._v(" "),_c('b-input',{staticClass:"form-control mb-3",attrs:{"placeholder":_vm.trans.main.login},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.focusPasswordInput($event)}},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}}),_vm._v(" "),_c('b-input',{staticClass:"form-control mb-3",attrs:{"placeholder":_vm.trans.main.password,"type":"password","id":"input_password","autocomplete":"curent-password"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.auth($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-button',{staticClass:"px-4 mb-4 w-100 btn-success",on:{"click":_vm.auth}},[_vm._v(_vm._s(_vm.trans.main.button_login))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84bf1c92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(927);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84bf1c92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('table',{staticClass:"table "},[_c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("ID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.user.name))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(_vm.$trans.user.login))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.$router.push({name: 'UserNew'})}}},[_vm._v(_vm._s(_vm.$trans.main.button_add_user))])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user){return _c('tr',[_c('td',{on:{"click":function($event){return _vm.editUser(user)}}},[_vm._v(_vm._s(user.id))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editUser(user)}}},[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.editUser(user)}}},[_vm._v(_vm._s(user.login))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){return _vm.deleteUser(user)}}},[_vm._v(_vm._s(_vm.$trans.main.button_delete))])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix btn-group col-md-2 offset-md-5"},[(_vm.page != 1)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.page--}}},[_vm._v(" <<")]):_vm._e(),_vm._v(" "),_vm._l((_vm.pages.slice(_vm.page-1, _vm.page+5)),function(pageNumber){return _c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.page = pageNumber}}},[_vm._v(" "+_vm._s(pageNumber)+"\n    ")])}),_vm._v(" "),(_vm.page < _vm.pages.length)?_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.page++}}},[_vm._v(" >>\n    ")]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e428a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__ = __webpack_require__(929);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e428a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-form',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"login"}},[_vm._v("Name")]),_vm._v(" "),_c('b-input',{attrs:{"id":"login"},model:{value:(_vm.user.login),callback:function ($$v) {_vm.$set(_vm.user, "login", $$v)},expression:"user.login"}}),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_vm._v("Benutzername")]),_vm._v(" "),_c('b-input',{model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"admin","id":"type","unchecked-value":"user"},model:{value:(_vm.user.type),callback:function ($$v) {_vm.$set(_vm.user, "type", $$v)},expression:"user.type"}},[_vm._v("\n        "+_vm._s(_vm.$trans.user.is_admin)+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.change()}}},[_vm._v(_vm._s(_vm.$trans.main.button_save))])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('h4',[_vm._v("Neues Passwort")]),_vm._v(" "),_c('b-form-row',[_c('div',{staticClass:"col"},[_c('b-input',{model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.newPassword()}}},[_vm._v(_vm._s(_vm.$trans.main.button_save))])],1)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNew_vue__ = __webpack_require__(611);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046236d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserNew_vue__ = __webpack_require__(931);
var normalizeComponent = __webpack_require__(50)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046236d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-form',[_c('label',{attrs:{"for":"login"}},[_vm._v("Name")]),_vm._v(" "),_c('b-input',{attrs:{"id":"login"},model:{value:(_vm.user.login),callback:function ($$v) {_vm.$set(_vm.user, "login", $$v)},expression:"user.login"}}),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_vm._v("Benutzername")]),_vm._v(" "),_c('b-input',{model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}}),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_vm._v("Passwort")]),_vm._v(" "),_c('b-input',{model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"admin","id":"type","unchecked-value":"user"},model:{value:(_vm.user.type),callback:function ($$v) {_vm.$set(_vm.user, "type", $$v)},expression:"user.type"}},[_vm._v("\n      "+_vm._s(_vm.$trans.user.is_admin)+"\n    ")]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.change()}}},[_vm._v(_vm._s(_vm.$trans.main.button_save))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[612]);


// WEBPACK FOOTER //
// static/js/app.a47f9db99db9757d9555.js